var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandCoding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-311",
    d: "M77.66,252.53c-95.18,55-95.17,144,0,199s249.49,55,344.67,0,95.17-144,0-199S172.84,197.57,77.66,252.53Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-311"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "24.5 334.05 24.5 353.4 164.21 434.2 164.21 414.85 24.5 334.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.21 414.85 425.88 263.76 425.88 283.11 164.21 434.2 164.21 414.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.21 407.52 19.57 323.9 285.33 170.44 429.97 254.07 164.21 407.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.57 323.9 19.57 334.16 164.21 417.79 164.21 407.52 19.57 323.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.57 323.9 19.57 334.16 164.21 417.79 164.21 407.52 19.57 323.9"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "164.21 417.79 429.97 264.33 429.97 254.07 164.21 407.52 164.21 417.79",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-311",
    d: "M118.31,361.93a6.18,6.18,0,0,1-3-.76L66.46,333a3.47,3.47,0,0,1,0-6.24l46.7-27a6.43,6.43,0,0,1,6.1,0l48.79,28.17a3.47,3.47,0,0,1,0,6.25l-46.69,27A6.14,6.14,0,0,1,118.31,361.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.71,331.5,120,357.37a4,4,0,0,1-3.58,0l-46.73-27a3.91,3.91,0,0,1-1.77-3.1l0-3.91a4,4,0,0,1,1.81-3.1l44.73-25.88a3.94,3.94,0,0,1,3.57,0l46.74,27a3.9,3.9,0,0,1,1.76,3.1l0,3.92A4,4,0,0,1,164.71,331.5Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,320.28a4.1,4.1,0,0,0-1.81,3.1l0,3.91a3.87,3.87,0,0,0,1.76,3.1l46.73,27a3.71,3.71,0,0,0,1.87.42v-8a3.64,3.64,0,0,1-1.79-.42l-46.73-27C68.84,321.82,68.69,320.89,69.74,320.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,321.57c.71.57.63,1.37-.26,1.88l-44.73,25.87a3.59,3.59,0,0,1-1.79.43v8.05a3.52,3.52,0,0,0,1.71-.43l44.73-25.88a4,4,0,0,0,1.81-3.09l0-3.92A3.94,3.94,0,0,0,165,321.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.78,323.45l-44.73,25.88a4,4,0,0,1-3.58,0L86.78,332.18l-17-9.84a1.09,1.09,0,0,1,0-2.06l44.73-25.88a3.94,3.94,0,0,1,3.57,0l46.74,27A1.1,1.1,0,0,1,164.78,323.45Z",
    style: {
      fill: "#4169E1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95,333.49a1.39,1.39,0,0,1-.67-.61,1.49,1.49,0,0,1,0-.68l1.06-11.59a.35.35,0,0,1,.08-.15l.1-.08a1,1,0,0,1,.61-.1,1.64,1.64,0,0,1,.69.21l5.7,3.29c.47.27.71.53.72.77a2.09,2.09,0,0,1,0,.59l-.75,4.91,8.46-.46c.28,0,.63,0,1,0a2.82,2.82,0,0,1,1.34.42l5.71,3.29a.76.76,0,0,1,.37.4.31.31,0,0,1-.19.35l-.13.06-.26,0-20.07.61a7.3,7.3,0,0,1-1.18,0,2.94,2.94,0,0,1-1.07-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,317.54a2,2,0,0,1-.37-.15A.69.69,0,0,1,95,317a.3.3,0,0,1,.18-.36l3.46-2a1.9,1.9,0,0,1,1.15-.25,4.46,4.46,0,0,1,1.07.19l37.41,11.29a2.81,2.81,0,0,1,.37.15.7.7,0,0,1,.37.42.3.3,0,0,1-.18.36l-3.54,2.05a2,2,0,0,1-1.1.25,5.57,5.57,0,0,1-1.12-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.88,309.85a1.41,1.41,0,0,1,.66.61,1.49,1.49,0,0,1,.05.68l-1.06,11.59a.35.35,0,0,1-.08.15l-.1.08a1,1,0,0,1-.61.1,1.68,1.68,0,0,1-.69-.21l-5.7-3.29c-.47-.27-.71-.53-.73-.78a1.86,1.86,0,0,1,0-.6l.78-4.89-8.49.44c-.28,0-.62,0-1,0a2.68,2.68,0,0,1-1.32-.41l-5.71-3.29a.76.76,0,0,1-.37-.4.31.31,0,0,1,.19-.35l.14-.06a1.7,1.7,0,0,1,.26-.05l20.06-.61a7.43,7.43,0,0,1,1.19,0,3,3,0,0,1,1.06.38Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.49,65.75l-8-4.57a.75.75,0,0,0-.37-.09,1,1,0,0,0-.45.11l-5.44,2.45a2.4,2.4,0,0,1,.16-1.32l6.28-12.66a1.41,1.41,0,0,0-.56-1.84l-6.81-3.93,0,0-7.92-4.55a1.43,1.43,0,0,0-1.88.44l-7.82,11.77a2.52,2.52,0,0,1-1,.79l-.6-6a.93.93,0,0,0-.4-.72l-8-4.58a.69.69,0,0,0-.32-.08,1.07,1.07,0,0,0-.53.16l-10.58,6.11a2.84,2.84,0,0,0-1.27,2L105.92,61a3.89,3.89,0,0,1-1.1,2.2A62.12,62.12,0,0,0,99,69.42a2,2,0,0,1-2.08.59l-6.79-2.37a1.66,1.66,0,0,0-1.91.7L80.39,81.82a1.64,1.64,0,0,0,.34,2l5.45,4.7a2,2,0,0,1,.53,2.09,63.43,63.43,0,0,0-2.45,8.21,4,4,0,0,1-1.35,2.05l-9.67,6.8a2.84,2.84,0,0,0-1.08,2.08V122a.84.84,0,0,0,.38.78h0l8,4.57h0a.88.88,0,0,0,.82,0l5.44-2.45a2.32,2.32,0,0,1-.17,1.32l-6.27,12.66a1.42,1.42,0,0,0,.55,1.84l9.57,5.5h0l5.19,3a1.43,1.43,0,0,0,1.87-.44L105.34,137a2.37,2.37,0,0,1,1-.79l.6,6a.89.89,0,0,0,.4.72l8,4.57h0a.84.84,0,0,0,.87-.06l10.58-6.11a2.85,2.85,0,0,0,1.26-2l1.06-11.77a4,4,0,0,1,1.1-2.2,63.31,63.31,0,0,0,5.88-6.22,2,2,0,0,1,2.08-.59l6.79,2.37a1.65,1.65,0,0,0,1.91-.71l7.78-13.47a1.66,1.66,0,0,0-.34-2l-5.45-4.7a2,2,0,0,1-.53-2.1,63.3,63.3,0,0,0,2.45-8.2,4,4,0,0,1,1.35-2l9.67-6.8a2.87,2.87,0,0,0,1.08-2.08V66.54A.87.87,0,0,0,162.49,65.75Zm-48.67,46.66a15.85,15.85,0,0,1-8.4,2.43,16.3,16.3,0,0,1-1.8-8c0-11.4,8-25.26,17.87-31a15.8,15.8,0,0,1,8.42-2.42,16.32,16.32,0,0,1,1.79,8C131.7,92.85,123.69,106.71,113.82,112.41Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.49,65.75l-8-4.57a.75.75,0,0,0-.37-.09,1,1,0,0,0-.45.11l-5.44,2.45a2.4,2.4,0,0,1,.16-1.32l6.28-12.66a1.41,1.41,0,0,0-.56-1.84l-6.81-3.93,0,0-7.92-4.55a1.43,1.43,0,0,0-1.88.44l-7.82,11.77a2.52,2.52,0,0,1-1,.79l-.6-6a.93.93,0,0,0-.4-.72l-8-4.58a.69.69,0,0,0-.32-.08,1.07,1.07,0,0,0-.53.16l-10.58,6.11a2.84,2.84,0,0,0-1.27,2L105.92,61a3.89,3.89,0,0,1-1.1,2.2A62.12,62.12,0,0,0,99,69.42a2,2,0,0,1-2.08.59l-6.79-2.37a1.66,1.66,0,0,0-1.91.7L80.39,81.82a1.64,1.64,0,0,0,.34,2l5.45,4.7a2,2,0,0,1,.53,2.09,63.43,63.43,0,0,0-2.45,8.21,4,4,0,0,1-1.35,2.05l-9.67,6.8a2.84,2.84,0,0,0-1.08,2.08V122a.84.84,0,0,0,.38.78h0l8,4.57h0a.88.88,0,0,0,.82,0l5.44-2.45a2.32,2.32,0,0,1-.17,1.32l-6.27,12.66a1.42,1.42,0,0,0,.55,1.84l9.57,5.5h0l5.19,3a1.43,1.43,0,0,0,1.87-.44L105.34,137a2.37,2.37,0,0,1,1-.79l.6,6a.89.89,0,0,0,.4.72l8,4.57h0a.84.84,0,0,0,.87-.06l10.58-6.11a2.85,2.85,0,0,0,1.26-2l1.06-11.77a4,4,0,0,1,1.1-2.2,63.31,63.31,0,0,0,5.88-6.22,2,2,0,0,1,2.08-.59l6.79,2.37a1.65,1.65,0,0,0,1.91-.71l7.78-13.47a1.66,1.66,0,0,0-.34-2l-5.45-4.7a2,2,0,0,1-.53-2.1,63.3,63.3,0,0,0,2.45-8.2,4,4,0,0,1,1.35-2l9.67-6.8a2.87,2.87,0,0,0,1.08-2.08V66.54A.87.87,0,0,0,162.49,65.75Zm-48.67,46.66a15.85,15.85,0,0,1-8.4,2.43,16.3,16.3,0,0,1-1.8-8c0-11.4,8-25.26,17.87-31a15.8,15.8,0,0,1,8.42-2.42,16.32,16.32,0,0,1,1.79,8C131.7,92.85,123.69,106.71,113.82,112.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,123.79a1.11,1.11,0,0,0-1.56-.73l-4,1.79a2.36,2.36,0,0,1-.18,1.33l-6.28,12.65a1.44,1.44,0,0,0,.56,1.85l9.56,5.5-1.6-.94a1.4,1.4,0,0,1-.56-1.84l6.28-12.65a2.6,2.6,0,0,0-.15-2.29A21.48,21.48,0,0,1,92.3,123.79Zm22.94,23.6a1,1,0,0,1-.32-.68l-1-10.27a1.11,1.11,0,0,0-1.41-1,21.87,21.87,0,0,1-5.1.52,2.38,2.38,0,0,0-1,.22l.6,6a.88.88,0,0,0,.41.71h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38,39.33a1.42,1.42,0,0,0-1.87.44l-7.83,11.77a1.89,1.89,0,0,1-.52.49l8,4.58a2,2,0,0,0,.52-.52l7.81-11.76a1.46,1.46,0,0,1,1.72-.52Zm15.14,21.84h0a.94.94,0,0,0-.82,0l-5.44,2.46a2.59,2.59,0,0,0,.32,1,21,21,0,0,1,2,4.44,1.57,1.57,0,0,1,.09.23,1.26,1.26,0,0,0,.28.49l.13.12a.94.94,0,0,0,.31.17,1.13,1.13,0,0,0,.58,0,.79.79,0,0,0,.26-.08l9.42-4.25a1.13,1.13,0,0,1,.24-.08.59.59,0,0,1,.32,0,.54.54,0,0,1,.27.09h0ZM119.67,41.06a.86.86,0,0,0-.85.08l-10.58,6.11a2.8,2.8,0,0,0-1.06,1.27l7.95,4.57a2.74,2.74,0,0,1,1.06-1.27l10.58-6.12a.9.9,0,0,1,.81-.1Zm-36,59a3.05,3.05,0,0,1-.73.78l-9.67,6.81a2.41,2.41,0,0,0-.64.73L80.54,113a2.32,2.32,0,0,1,.65-.73l9.67-6.8a3.18,3.18,0,0,0,.75-.79Zm5.88-32.52a1.66,1.66,0,0,0-1.36.79L80.38,81.81a1.69,1.69,0,0,0-.17,1l8,4.58a1.57,1.57,0,0,1,.18-1L96.12,72.9a1.68,1.68,0,0,1,1.26-.78Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38,39.33a1.42,1.42,0,0,0-1.87.44l-7.83,11.77a1.89,1.89,0,0,1-.52.49l8,4.58a2,2,0,0,0,.52-.52l7.81-11.76a1.46,1.46,0,0,1,1.72-.52Zm15.14,21.84h0a.94.94,0,0,0-.82,0l-5.44,2.46a2.59,2.59,0,0,0,.32,1,21,21,0,0,1,2,4.44,1.57,1.57,0,0,1,.09.23,1.26,1.26,0,0,0,.28.49l.13.12a.94.94,0,0,0,.31.17,1.13,1.13,0,0,0,.58,0,.79.79,0,0,0,.26-.08l9.42-4.25a1.13,1.13,0,0,1,.24-.08.59.59,0,0,1,.32,0,.54.54,0,0,1,.27.09h0ZM119.67,41.06a.86.86,0,0,0-.85.08l-10.58,6.11a2.8,2.8,0,0,0-1.06,1.27l7.95,4.57a2.74,2.74,0,0,1,1.06-1.27l10.58-6.12a.9.9,0,0,1,.81-.1Zm-36,59a3.05,3.05,0,0,1-.73.78l-9.67,6.81a2.41,2.41,0,0,0-.64.73L80.54,113a2.32,2.32,0,0,1,.65-.73l9.67-6.8a3.18,3.18,0,0,0,.75-.79Zm5.88-32.52a1.66,1.66,0,0,0-1.36.79L80.38,81.81a1.69,1.69,0,0,0-.17,1l8,4.58a1.57,1.57,0,0,1,.18-1L96.12,72.9a1.68,1.68,0,0,1,1.26-.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.86,78.76V66.54a.79.79,0,0,0-1.2-.78L152.24,70a1.12,1.12,0,0,1-1.57-.72,20.57,20.57,0,0,0-2.1-4.67,2.61,2.61,0,0,1-.14-2.28l6.28-12.66a1.43,1.43,0,0,0-.56-1.84l-6.81-3.94a1.45,1.45,0,0,0-1.88.44L137.64,56.1a2.58,2.58,0,0,1-2,1,21.21,21.21,0,0,0-5.09.52,1.11,1.11,0,0,1-1.41-1l-1-10.28a.79.79,0,0,0-1.27-.66L116.2,51.81a2.85,2.85,0,0,0-1.26,2l-1.06,11.77a4,4,0,0,1-1.1,2.2A64.45,64.45,0,0,0,106.9,74a2,2,0,0,1-2.08.59L98,72.2a1.65,1.65,0,0,0-1.91.71L88.34,86.38a1.67,1.67,0,0,0,.34,2l5.45,4.69a2,2,0,0,1,.53,2.1,63.3,63.3,0,0,0-2.45,8.2,4,4,0,0,1-1.35,2.05l-9.67,6.8a2.87,2.87,0,0,0-1.08,2.08v12.22a.79.79,0,0,0,1.21.78l9.41-4.25a1.12,1.12,0,0,1,1.57.73,21.48,21.48,0,0,0,2.1,4.67,2.62,2.62,0,0,1,.15,2.28L88.27,143.4a1.41,1.41,0,0,0,.55,1.84l6.82,3.93a1.42,1.42,0,0,0,1.87-.43L105.33,137a2.64,2.64,0,0,1,2-1,20.82,20.82,0,0,0,5.1-.51,1.11,1.11,0,0,1,1.41,1l1,10.28a.79.79,0,0,0,1.28.65l10.58-6.1a2.85,2.85,0,0,0,1.26-2l1.06-11.77a3.92,3.92,0,0,1,1.1-2.2,64.45,64.45,0,0,0,5.88-6.22,2,2,0,0,1,2.08-.59l6.79,2.37a1.67,1.67,0,0,0,1.91-.71l7.77-13.47a1.65,1.65,0,0,0-.34-2L148.84,100a2,2,0,0,1-.52-2.1,63.23,63.23,0,0,0,2.44-8.2,3.93,3.93,0,0,1,1.36-2l9.66-6.8A2.86,2.86,0,0,0,162.86,78.76Zm-41.37,38.41c-9.87,5.7-17.88,1.08-17.88-10.32s8-25.26,17.88-31,17.87-1.08,17.87,10.32S131.36,111.47,121.49,117.17Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.66,65.76,152.25,70a1.12,1.12,0,0,1-1.57-.73,21.48,21.48,0,0,0-2.1-4.67,2.62,2.62,0,0,1-.15-2.28l6.28-12.66a1.41,1.41,0,0,0-.56-1.84l-6.81-3.93a1.42,1.42,0,0,0-1.87.43L137.64,56.1a2.57,2.57,0,0,1-2,1,20.82,20.82,0,0,0-5.1.51,1.11,1.11,0,0,1-1.41-1l-1-10.28a.79.79,0,0,0-1.28-.65l-10.58,6.1a2.85,2.85,0,0,0-1.26,2l-1.06,11.77a3.92,3.92,0,0,1-1.1,2.2A64.45,64.45,0,0,0,106.9,74a2,2,0,0,1-2.08.59L98,72.2a1.67,1.67,0,0,0-1.91.71L88.34,86.38a1.67,1.67,0,0,0,.34,2l5.46,4.69a2,2,0,0,1,.52,2.1,63.23,63.23,0,0,0-2.44,8.2,3.93,3.93,0,0,1-1.36,2.05l-9.66,6.81a2.82,2.82,0,0,0-1.08,2.08v12.21a.79.79,0,0,0,1.2.78l9.42-4.24a1.12,1.12,0,0,1,1.57.72,20.57,20.57,0,0,0,2.1,4.67,2.61,2.61,0,0,1,.14,2.28L88.27,143.4a1.43,1.43,0,0,0,.56,1.84l6.81,3.94a1.45,1.45,0,0,0,1.88-.44L105.34,137a2.61,2.61,0,0,1,2-1,21.21,21.21,0,0,0,5.09-.52,1.11,1.11,0,0,1,1.41,1l1,10.28a.79.79,0,0,0,1.27.66l10.58-6.11a2.85,2.85,0,0,0,1.26-2l1.06-11.77a4,4,0,0,1,1.1-2.2,63.31,63.31,0,0,0,5.88-6.22,2,2,0,0,1,2.08-.59l6.79,2.37a1.65,1.65,0,0,0,1.91-.71l7.78-13.47a1.66,1.66,0,0,0-.34-2l-5.45-4.7a2,2,0,0,1-.53-2.1,63.3,63.3,0,0,0,2.45-8.2,4,4,0,0,1,1.35-2l9.67-6.8a2.87,2.87,0,0,0,1.08-2.08V66.54A.79.79,0,0,0,161.66,65.76Zm-40.17,51.42c-9.87,5.7-17.87,1.08-17.87-10.32s8-25.26,17.87-31,17.88-1.08,17.88,10.32S131.36,111.48,121.49,117.18Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,66.8a4.86,4.86,0,0,1,1.3-2.64l5.34-4.91a3.28,3.28,0,0,0,.9-2.63l-1-5.83a1.07,1.07,0,0,0-.51-.8h0L221,46.33h0a1,1,0,0,0-1.1.1L217.59,48l2.21-6a1.32,1.32,0,0,0-.61-1.66h0l-6.33-3.66h0a1.68,1.68,0,0,0-.41-.17l-4-.9a2.16,2.16,0,0,0-2.27,1.06l-3.78,7.2a3.71,3.71,0,0,1-1.51,1.39l-.17-.57a1.17,1.17,0,0,0-.51-.7h0l-6.35-3.66h0a1,1,0,0,0-1.19.16l-6,4.74a3.37,3.37,0,0,0-1.15,2.55l.36,5.74a4.49,4.49,0,0,1-.93,2.77,46,46,0,0,0-2.8,3.7,3.13,3.13,0,0,1-2.45,1.25l-3.88-.2a2.49,2.49,0,0,0-2.22,1.37l-3.64,8.17a1.54,1.54,0,0,0,.62,2h0L174.84,75a1.84,1.84,0,0,1,.1,1.11,36.59,36.59,0,0,0-.67,3.9,4.89,4.89,0,0,1-1.3,2.64l-5.34,4.91a3.21,3.21,0,0,0-.9,2.63l1,5.82a1.13,1.13,0,0,0,.48.79h0l6.36,3.67h0a1,1,0,0,0,1.1-.11L178,98.83l-2.22,6a1.33,1.33,0,0,0,.54,1.63h0l6.36,3.67v0a1.48,1.48,0,0,0,.44.2l4,.9a2.19,2.19,0,0,0,2.28-1.06l3.78-7.2a3.74,3.74,0,0,1,1.51-1.4l.17.58a1.14,1.14,0,0,0,.52.7h0l6.3,3.63h0l.07,0h0a1.05,1.05,0,0,0,1.15-.18l6-4.74A3.37,3.37,0,0,0,210.05,99l-.36-5.73a4.56,4.56,0,0,1,.94-2.77q1.49-1.77,2.8-3.71a3.12,3.12,0,0,1,2.45-1.24l3.87.19A2.49,2.49,0,0,0,222,84.42l3.64-8.17a1.54,1.54,0,0,0-.81-2.06l-3.13-1.34a1.92,1.92,0,0,1-1.07-2.15C220.9,69.38,221.13,68.08,221.28,66.8ZM189.12,84.52c-1.18-6.86,3.16-16.58,9.69-21.71a13.11,13.11,0,0,1,6.86-3.07,10.21,10.21,0,0,1,.76,2.53c1.18,6.86-3.16,16.58-9.69,21.71A13.15,13.15,0,0,1,189.9,87,9.55,9.55,0,0,1,189.12,84.52Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,66.8a4.86,4.86,0,0,1,1.3-2.64l5.34-4.91a3.28,3.28,0,0,0,.9-2.63l-1-5.83a1.07,1.07,0,0,0-.51-.8h0L221,46.33h0a1,1,0,0,0-1.1.1L217.59,48l2.21-6a1.32,1.32,0,0,0-.61-1.66h0l-6.33-3.66h0a1.68,1.68,0,0,0-.41-.17l-4-.9a2.16,2.16,0,0,0-2.27,1.06l-3.78,7.2a3.71,3.71,0,0,1-1.51,1.39l-.17-.57a1.17,1.17,0,0,0-.51-.7h0l-6.35-3.66h0a1,1,0,0,0-1.19.16l-6,4.74a3.37,3.37,0,0,0-1.15,2.55l.36,5.74a4.49,4.49,0,0,1-.93,2.77,46,46,0,0,0-2.8,3.7,3.13,3.13,0,0,1-2.45,1.25l-3.88-.2a2.49,2.49,0,0,0-2.22,1.37l-3.64,8.17a1.54,1.54,0,0,0,.62,2h0L174.84,75a1.84,1.84,0,0,1,.1,1.11,36.59,36.59,0,0,0-.67,3.9,4.89,4.89,0,0,1-1.3,2.64l-5.34,4.91a3.21,3.21,0,0,0-.9,2.63l1,5.82a1.13,1.13,0,0,0,.48.79h0l6.36,3.67h0a1,1,0,0,0,1.1-.11L178,98.83l-2.22,6a1.33,1.33,0,0,0,.54,1.63h0l6.36,3.67v0a1.48,1.48,0,0,0,.44.2l4,.9a2.19,2.19,0,0,0,2.28-1.06l3.78-7.2a3.74,3.74,0,0,1,1.51-1.4l.17.58a1.14,1.14,0,0,0,.52.7h0l6.3,3.63h0l.07,0h0a1.05,1.05,0,0,0,1.15-.18l6-4.74A3.37,3.37,0,0,0,210.05,99l-.36-5.73a4.56,4.56,0,0,1,.94-2.77q1.49-1.77,2.8-3.71a3.12,3.12,0,0,1,2.45-1.24l3.87.19A2.49,2.49,0,0,0,222,84.42l3.64-8.17a1.54,1.54,0,0,0-.81-2.06l-3.13-1.34a1.92,1.92,0,0,1-1.07-2.15C220.9,69.38,221.13,68.08,221.28,66.8ZM189.12,84.52c-1.18-6.86,3.16-16.58,9.69-21.71a13.11,13.11,0,0,1,6.86-3.07,10.21,10.21,0,0,1,.76,2.53c1.18,6.86-3.16,16.58-9.69,21.71A13.15,13.15,0,0,1,189.9,87,9.55,9.55,0,0,1,189.12,84.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.14,97.32a1.54,1.54,0,0,0-2.14-.49l-3.05,2-2.21,6a1.33,1.33,0,0,0,.53,1.63l6.29,3.62a1.33,1.33,0,0,1-.48-1.59l2.73-7.37a2.67,2.67,0,0,0-.62-2.53A10,10,0,0,1,183.14,97.32Zm18.55,9.18a1.17,1.17,0,0,1-.51-.7l-1.36-4.51a1.37,1.37,0,0,0-1.9-.87,18,18,0,0,1-2.48.82,3.14,3.14,0,0,0-.78.32l.17.59a1.21,1.21,0,0,0,.53.69h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.78,61a2.54,2.54,0,0,1-1.11.23L175.79,61a2.4,2.4,0,0,0-1.6.58l6.34,3.66a2.54,2.54,0,0,1,1.6-.59l3.89.19a2.47,2.47,0,0,0,1.1-.21Zm13.07-20.68a1,1,0,0,0-1.18.17l-6,4.73a3.34,3.34,0,0,0-1,1.58L192,50.42a3.18,3.18,0,0,1,1-1.58l6-4.73a1,1,0,0,1,1.2-.16h0ZM172.9,82.69l-5.27,4.85a3.08,3.08,0,0,0-.82,1.52l6.33,3.64a3.15,3.15,0,0,1,.83-1.5l5.28-4.84Zm40-46a1,1,0,0,0-.42-.16l-4-.91a2.19,2.19,0,0,0-2.27,1.06l-3.78,7.2a3.38,3.38,0,0,1-.86,1l6.34,3.66a3.52,3.52,0,0,0,.86-1l3.78-7.21a2.17,2.17,0,0,1,2.28-1.05l4,.9a2.86,2.86,0,0,1,.41.15Zm8.1,9.69h0a1,1,0,0,0-1.1.1L217.59,48l-.51,1.35a2.64,2.64,0,0,0,.63,2.55,10.76,10.76,0,0,1,1,1.27,2.8,2.8,0,0,0,.28.31,1.81,1.81,0,0,0,.23.18,1.64,1.64,0,0,0,.54.21,1.33,1.33,0,0,0,.71,0,.91.91,0,0,0,.38-.17l5.34-3.51a1.6,1.6,0,0,1,.4-.19.78.78,0,0,1,.45,0,1,1,0,0,1,.24.07Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.78,61a2.54,2.54,0,0,1-1.11.23L175.79,61a2.4,2.4,0,0,0-1.6.58l6.34,3.66a2.54,2.54,0,0,1,1.6-.59l3.89.19a2.47,2.47,0,0,0,1.1-.21Zm13.07-20.68a1,1,0,0,0-1.18.17l-6,4.73a3.34,3.34,0,0,0-1,1.58L192,50.42a3.18,3.18,0,0,1,1-1.58l6-4.73a1,1,0,0,1,1.2-.16h0ZM172.9,82.69l-5.27,4.85a3.08,3.08,0,0,0-.82,1.52l6.33,3.64a3.15,3.15,0,0,1,.83-1.5l5.28-4.84Zm40-46a1,1,0,0,0-.42-.16l-4-.91a2.19,2.19,0,0,0-2.27,1.06l-3.78,7.2a3.38,3.38,0,0,1-.86,1l6.34,3.66a3.52,3.52,0,0,0,.86-1l3.78-7.21a2.17,2.17,0,0,1,2.28-1.05l4,.9a2.86,2.86,0,0,1,.41.15Zm8.1,9.69h0a1,1,0,0,0-1.1.1L217.59,48l-.51,1.35a2.64,2.64,0,0,0,.63,2.55,10.76,10.76,0,0,1,1,1.27,2.8,2.8,0,0,0,.28.31,1.81,1.81,0,0,0,.23.18,1.64,1.64,0,0,0,.54.21,1.33,1.33,0,0,0,.71,0,.91.91,0,0,0,.38-.17l5.34-3.51a1.6,1.6,0,0,1,.4-.19.78.78,0,0,1,.45,0,1,1,0,0,1,.24.07Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,56.62l-1-5.83a1,1,0,0,0-1.59-.69l-5.33,3.52a1.54,1.54,0,0,1-2.14-.49,10.83,10.83,0,0,0-1-1.27,2.66,2.66,0,0,1-.63-2.54L219.8,42a1.34,1.34,0,0,0-1-1.83l-4-.9a2.16,2.16,0,0,0-2.28,1.06l-3.78,7.2a4,4,0,0,1-2.29,1.72A19.83,19.83,0,0,0,204,50a1.37,1.37,0,0,1-1.9-.87l-1.36-4.51a1,1,0,0,0-1.7-.54l-6,4.74a3.33,3.33,0,0,0-1.14,2.55l.36,5.74a4.56,4.56,0,0,1-.94,2.77c-1,1.18-1.92,2.42-2.8,3.7A3.13,3.13,0,0,1,186,64.86l-3.87-.2A2.5,2.5,0,0,0,179.91,66l-3.64,8.17a1.55,1.55,0,0,0,.81,2.06l3.13,1.34a1.92,1.92,0,0,1,1.07,2.15,39.3,39.3,0,0,0-.67,3.9,4.89,4.89,0,0,1-1.3,2.64L174,91.2a3.28,3.28,0,0,0-.9,2.63l1,5.82a1,1,0,0,0,1.59.69L181,96.83a1.54,1.54,0,0,1,2.14.49,10.83,10.83,0,0,0,1,1.27,2.66,2.66,0,0,1,.63,2.54l-2.72,7.36a1.34,1.34,0,0,0,1,1.83l4,.9a2.19,2.19,0,0,0,2.28-1.06l3.78-7.2a3.93,3.93,0,0,1,2.29-1.72,19.83,19.83,0,0,0,2.47-.82,1.37,1.37,0,0,1,1.9.87l1.36,4.51a1,1,0,0,0,1.7.54l6-4.74A3.37,3.37,0,0,0,210.05,99l-.36-5.73a4.56,4.56,0,0,1,.94-2.77q1.49-1.77,2.8-3.71a3.12,3.12,0,0,1,2.45-1.24l3.87.19A2.49,2.49,0,0,0,222,84.42l3.64-8.17a1.54,1.54,0,0,0-.81-2.06l-3.13-1.34a1.92,1.92,0,0,1-1.07-2.15c.29-1.32.52-2.62.67-3.9a4.86,4.86,0,0,1,1.3-2.64l5.34-4.91A3.28,3.28,0,0,0,228.82,56.62Zm-25.74,31c-6.53,5.14-12.78,3.74-14-3.12s3.16-16.58,9.69-21.71,12.78-3.74,14,3.12S209.61,82.51,203.08,87.64Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,56.62l-1-5.83a1,1,0,0,0-1.59-.69l-5.33,3.52a1.54,1.54,0,0,1-2.14-.49,10.83,10.83,0,0,0-1-1.27,2.66,2.66,0,0,1-.63-2.54L219.8,42a1.34,1.34,0,0,0-1-1.83l-4-.9a2.16,2.16,0,0,0-2.28,1.06l-3.78,7.2a4,4,0,0,1-2.29,1.72A19.83,19.83,0,0,0,204,50a1.37,1.37,0,0,1-1.9-.87l-1.36-4.51a1,1,0,0,0-1.7-.54l-6,4.74a3.33,3.33,0,0,0-1.14,2.55l.36,5.74a4.56,4.56,0,0,1-.94,2.77c-1,1.18-1.92,2.42-2.8,3.7A3.13,3.13,0,0,1,186,64.86l-3.87-.2A2.5,2.5,0,0,0,179.91,66l-3.64,8.17a1.55,1.55,0,0,0,.81,2.06l3.13,1.34a1.92,1.92,0,0,1,1.07,2.15,39.3,39.3,0,0,0-.67,3.9,4.89,4.89,0,0,1-1.3,2.64L174,91.2a3.28,3.28,0,0,0-.9,2.63l1,5.82a1,1,0,0,0,1.59.69L181,96.83a1.54,1.54,0,0,1,2.14.49,10.83,10.83,0,0,0,1,1.27,2.66,2.66,0,0,1,.63,2.54l-2.72,7.36a1.34,1.34,0,0,0,1,1.83l4,.9a2.19,2.19,0,0,0,2.28-1.06l3.78-7.2a3.93,3.93,0,0,1,2.29-1.72,19.83,19.83,0,0,0,2.47-.82,1.37,1.37,0,0,1,1.9.87l1.36,4.51a1,1,0,0,0,1.7.54l6-4.74A3.37,3.37,0,0,0,210.05,99l-.36-5.73a4.56,4.56,0,0,1,.94-2.77q1.49-1.77,2.8-3.71a3.12,3.12,0,0,1,2.45-1.24l3.87.19A2.49,2.49,0,0,0,222,84.42l3.64-8.17a1.54,1.54,0,0,0-.81-2.06l-3.13-1.34a1.92,1.92,0,0,1-1.07-2.15c.29-1.32.52-2.62.67-3.9a4.86,4.86,0,0,1,1.3-2.64l5.34-4.91A3.28,3.28,0,0,0,228.82,56.62Zm-25.74,31c-6.53,5.14-12.78,3.74-14-3.12s3.16-16.58,9.69-21.71,12.78-3.74,14,3.12S209.61,82.51,203.08,87.64Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drink--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-311"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-311",
    cx: 287.27,
    cy: 203.85,
    rx: 20.25,
    ry: 11.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.48,168c7.73-2.94,20.1-3.08,27.63-.3s7.58,7.4.11,10.34-19.83,3.08-27.62.31S265.76,170.92,273.48,168Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.48,168c7.73-2.94,20.1-3.08,27.63-.3s7.58,7.4.11,10.34-19.83,3.08-27.62.31S265.76,170.92,273.48,168Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Soda--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffe--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.63,154.86l41.29,0-4.22,48.24h0c-.18,2-1.73,3.93-4.69,5.44-6.31,3.22-16.7,3.22-23.23,0-3.06-1.51-4.66-3.46-4.85-5.44h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,155.71l39.45,0-4.07,46.56h0l-.07.77c-.16,1.76-1.66,3.45-4.23,4.76a25.28,25.28,0,0,1-11.15,2.32,26.2,26.2,0,0,1-11.32-2.33c-2.66-1.31-4.22-3-4.39-4.76l-.1-.65-4.08-46.71m-.92-.85,4.22,48.29h0c.19,2,1.79,3.93,4.85,5.44a27.25,27.25,0,0,0,11.7,2.41A26.11,26.11,0,0,0,299,208.59c3-1.51,4.51-3.46,4.69-5.44h0l4.22-48.24-41.29,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.57,158.92l-.75-8.25h5.24a18.14,18.14,0,0,1,2-1.08c8.62-4.11,22.37-4.11,30.7,0a16.76,16.76,0,0,1,1.89,1.08h5.11l-.75,8.25h0c0,2.69-2.08,5.38-6.25,7.44-8.33,4.1-22.08,4.1-30.7,0C267.72,164.3,265.57,161.61,265.57,158.92Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.57,158.92l-.75-8.25h5.24a18.14,18.14,0,0,1,2-1.08c8.62-4.11,22.37-4.11,30.7,0a16.76,16.76,0,0,1,1.89,1.08h5.11l-.75,8.25h0c0,2.69-2.08,5.38-6.25,7.44-8.33,4.1-22.08,4.1-30.7,0C267.72,164.3,265.57,161.61,265.57,158.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.51,143c8.92-4.25,23.13-4.25,31.75,0s8.62,11.13,0,15.37-22.83,4.25-31.75,0S262.6,147.22,271.51,143Z",
    style: {
      fill: "#4169E1"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.78,172.89l0,.79,0,.61-1.24,16.13c0,1.1-.74,2.19-2.18,3.17l-.39.25a16.54,16.54,0,0,1-2.3,1.09,37.31,37.31,0,0,1-12.39,2.16H286.3a37.93,37.93,0,0,1-11.72-1.87,15.3,15.3,0,0,1-3-1.38c-.13-.09-.26-.16-.38-.25-1.44-1-2.17-2.07-2.19-3.17l-1.24-16.13-.05-.7a.29.29,0,0,0,0,.09c.31,1.71,2.25,3.37,5.83,4.65a42.18,42.18,0,0,0,13.66,2,40.62,40.62,0,0,0,14-2.3C304.89,176.57,306.74,174.73,306.78,172.89Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.78,172.89l0,.79,0,.61-1.24,16.13c0,1.1-.74,2.19-2.18,3.17l-.39.25a16.54,16.54,0,0,1-2.3,1.09,37.31,37.31,0,0,1-12.39,2.16H286.3a37.93,37.93,0,0,1-11.72-1.87,15.3,15.3,0,0,1-3-1.38c-.13-.09-.26-.16-.38-.25-1.44-1-2.17-2.07-2.19-3.17l-1.24-16.13-.05-.7a.29.29,0,0,0,0,.09c.31,1.71,2.25,3.37,5.83,4.65a42.18,42.18,0,0,0,13.66,2,40.62,40.62,0,0,0,14-2.3C304.89,176.57,306.74,174.73,306.78,172.89Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.71,191.15a24.63,24.63,0,0,0,1.52-2.93,8.64,8.64,0,0,1,4.46-4,.56.56,0,0,1,.7.25c1,2,.43,4.78-1.57,6.82s-4.74,2.68-6.74,1.77c-.11,0-.14-.27-.05-.33A5.62,5.62,0,0,0,293.71,191.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,183.67a9.63,9.63,0,0,0-2.82,1.78,8.78,8.78,0,0,0-2,2.83,8.38,8.38,0,0,1-2.54,3.45.56.56,0,0,1-.78-.11c-1.35-2-.86-5.06,1.3-7.27s4.91-2.71,6.93-1.67A.55.55,0,0,1,298.6,183.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09,149h0l1.35-6.74,11.31-.12A40.4,40.4,0,0,1,293,142l11-.12,1.5,6.71h0c.74,2.44-.92,5-5,6.94-7,3.29-18.63,3.41-26,.29C270.16,154,268.38,151.42,269.09,149Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09,149h0l1.35-6.74,11.31-.12A40.4,40.4,0,0,1,293,142l11-.12,1.5,6.71h0c.74,2.44-.92,5-5,6.94-7,3.29-18.63,3.41-26,.29C270.16,154,268.38,151.42,269.09,149Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,137.87c6.67-2.87,17.34-3,23.85-.27s6.55,7.24.11,10.11-17.12,3-23.85.26S268.64,140.73,275.3,137.87Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66,143a2.09,2.09,0,0,0,.75,1,10.38,10.38,0,0,0,2.76,1.57,30.88,30.88,0,0,0,11.24,1.81,29.21,29.21,0,0,0,11-2.05,9.42,9.42,0,0,0,2.64-1.63,2,2,0,0,0,.68-1c0-.19-.59-1.36-3.38-2.52a29.39,29.39,0,0,0-11.05-1.81,30.68,30.68,0,0,0-11.19,2.06C273.35,141.54,272.67,142.72,272.66,143Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.66,143a2.09,2.09,0,0,0,.75,1,10.38,10.38,0,0,0,2.76,1.57,30.88,30.88,0,0,0,11.24,1.81,29.21,29.21,0,0,0,11-2.05,9.42,9.42,0,0,0,2.64-1.63,2,2,0,0,0,.68-1c0-.19-.59-1.36-3.38-2.52a29.39,29.39,0,0,0-11.05-1.81,30.68,30.68,0,0,0-11.19,2.06C273.35,141.54,272.67,142.72,272.66,143Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M273.41,143.9a10.38,10.38,0,0,0,2.76,1.57,30.88,30.88,0,0,0,11.24,1.81,29.21,29.21,0,0,0,11-2.05,9.42,9.42,0,0,0,2.64-1.63,9.51,9.51,0,0,0-2.67-1.58,29.3,29.3,0,0,0-11.06-1.8,30.27,30.27,0,0,0-11.19,2.06A10.2,10.2,0,0,0,273.41,143.9Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.41,143.9a10.38,10.38,0,0,0,2.76,1.57,30.88,30.88,0,0,0,11.24,1.81,29.21,29.21,0,0,0,11-2.05,9.42,9.42,0,0,0,2.64-1.63,9.51,9.51,0,0,0-2.67-1.58,29.3,29.3,0,0,0-11.06-1.8,30.27,30.27,0,0,0-11.19,2.06A10.2,10.2,0,0,0,273.41,143.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.12,144c-1-.62-2.17-.87-2.65-.55s-.08,1.09.9,1.72,2.17.88,2.65.55S281.1,144.62,280.12,144Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-311",
    d: "M110.29,281l82.06,47.36a7.48,7.48,0,0,0,6.74,0l122.1-70.5c1.86-1.08,1.86-2.82,0-3.89l-82.06-47.36a7.48,7.48,0,0,0-6.74,0l-122.1,70.5C108.43,278.16,108.43,279.91,110.29,281Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,277.69c0,1.9,1.42,3.12,3.18,4.14l72.07,41.6a7,7,0,0,0,6.36,0l116.26-67.12c1.76-1,3.18-2.32,3.18-4.22s-1.42-3.09-3.18-4.1l-72.06-41.61a7.07,7.07,0,0,0-6.37,0L120,273.5C118.24,274.52,116.82,275.78,116.82,277.69Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,277.69c0,1.9,1.42,3.12,3.18,4.14l72.07,41.6a7,7,0,0,0,6.36,0l116.26-67.12c1.76-1,3.18-2.32,3.18-4.22s-1.42-3.09-3.18-4.1l-72.06-41.61a7.07,7.07,0,0,0-6.37,0L120,273.5C118.24,274.52,116.82,275.78,116.82,277.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,277.18l72.07,41.6a7,7,0,0,0,6.36,0l116.26-67.12c1.76-1,1.76-2.66,0-3.67l-72.06-41.61a7.07,7.07,0,0,0-6.37,0L120,273.5C118.24,274.52,118.24,276.16,120,277.18Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,277.18l72.07,41.6a7,7,0,0,0,6.36,0l116.26-67.12c1.76-1,1.76-2.66,0-3.67l-72.06-41.61a7.07,7.07,0,0,0-6.37,0L120,273.5C118.24,274.52,118.24,276.16,120,277.18Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,319.55v4.64a6.45,6.45,0,0,1-3.18-.76L120,281.83c-1.75-1-3.18-2.24-3.18-4.14s1.28-3,2.93-4.05c-1.36,1-1.39,2.59.25,3.54l72.07,41.61A6.56,6.56,0,0,0,195.25,319.55Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,274l106.83-61.68a3.3,3.3,0,0,1,3,0l3.89,2.18a.92.92,0,0,1,0,1.74L136.71,278a3.3,3.3,0,0,1-3,0l-3.87-2.18A.91.91,0,0,1,129.84,274Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,274l106.83-61.68a3.3,3.3,0,0,1,3,0l3.89,2.18a.92.92,0,0,1,0,1.74L136.71,278a3.3,3.3,0,0,1-3,0l-3.87-2.18A.91.91,0,0,1,129.84,274Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,280.23l106.83-61.68a3,3,0,0,1,2.74-.15l27.81,16c.69.4.57,1.11-.26,1.59l-106.71,61.6a3.1,3.1,0,0,1-2.74.15l-27.93-16C139.38,281.42,139.5,280.71,140.33,280.23Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,280.23l106.83-61.68a3,3,0,0,1,2.74-.15l27.81,16c.69.4.57,1.11-.26,1.59l-106.71,61.6a3.1,3.1,0,0,1-2.74.15l-27.93-16C139.38,281.42,139.5,280.71,140.33,280.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,244.46l3.34-1.94c.15-.08.16-.2,0-.28l-3.2-1.84a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.09-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,232.9,244.46ZM228,237.77l-3.35,1.93c-.14.09-.15.21,0,.29l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.93c.15-.09.16-.21,0-.28l-3.2-1.85A.51.51,0,0,0,228,237.77ZM217.21,244l-5.66,3.27c-.14.08-.16.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l5.66-3.27c.14-.08.15-.2,0-.28L217.7,244A.53.53,0,0,0,217.21,244Zm5.92-3.41-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85A.51.51,0,0,0,223.13,240.6ZM210,248.17l-3.34,1.93c-.14.09-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.94c.14-.08.16-.2,0-.28l-3.2-1.84A.53.53,0,0,0,210,248.17ZM205.12,251l-3.35,1.93c-.14.08-.15.2,0,.28l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.93c.15-.09.16-.21,0-.28L205.6,251A.51.51,0,0,0,205.12,251Zm12.54,7.53L221,256.6c.15-.08.16-.2,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0L214,256.42c-.14.08-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,217.66,258.53Zm-4.89,2.83,3.35-1.93c.14-.09.15-.21,0-.29l-3.2-1.84a.51.51,0,0,0-.48,0l-3.35,1.94c-.14.08-.15.2,0,.28l3.2,1.84A.53.53,0,0,0,212.77,261.36Zm-4.89,2.82,3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85A.54.54,0,0,0,207.88,264.18ZM203,267l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.15.08-.16.21,0,.28l3.2,1.85A.54.54,0,0,0,203,267Zm25-19.72,3.35-1.93c.14-.08.15-.21,0-.28l-3.21-1.85a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.2,0,.28l3.2,1.85A.54.54,0,0,0,228,247.28Zm-5.46,8.43L230,251.4c.14-.08.15-.2,0-.28l-7.77-4.48a.53.53,0,0,0-.49,0l-3.86,2.23c-.14.08-.15.21,0,.28l4.12,2.38c.12.07.11.2,0,.28l-3.09,1.78c-.14.08-.15.21,0,.28l3.2,1.85A.56.56,0,0,0,222.55,255.71Zm-22.32-1.89-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85A.54.54,0,0,0,200.23,253.82Zm-4.89,2.82L192,258.57c-.14.08-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85A.54.54,0,0,0,195.34,256.64Zm-27.05,30.14a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm-12.06-7.56-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85A.54.54,0,0,0,156.23,279.22Zm6.2,5.66a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.15.08-.16.21,0,.28Zm13.49,3,3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.53.53,0,0,0,175.92,287.91Zm-5.38,2.84a.53.53,0,0,0,.49,0l3.34-1.94c.14-.08.16-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.34,1.93c-.14.09-.16.21,0,.29Zm-9.42-14.35-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85A.54.54,0,0,0,161.12,276.4Zm24.44-14.11-3.34,1.93c-.15.08-.16.2,0,.28l3.2,1.84a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85A.53.53,0,0,0,185.56,262.29ZM166,273.58l-3.35,1.93c-.14.08-.15.2,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85A.51.51,0,0,0,166,273.58Zm24.44-14.12-3.35,1.93c-.14.09-.15.21,0,.28l3.2,1.85a.51.51,0,0,0,.48,0l3.35-1.94c.14-.08.15-.2,0-.28l-3.2-1.84A.53.53,0,0,0,190.45,259.46Zm-9.78,5.65L177.33,267c-.15.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85A.56.56,0,0,0,180.67,265.11Zm-4.89,2.82-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85A.56.56,0,0,0,175.78,267.93Zm-4.89,2.82-3.34,1.93c-.14.09-.16.21,0,.29l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.94c.14-.08.16-.2,0-.28l-3.2-1.84A.53.53,0,0,0,170.89,270.75Zm22.33,1.9,3.34-1.93c.14-.09.16-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0l-3.34,1.94c-.14.08-.16.2,0,.28l3.2,1.84A.53.53,0,0,0,193.22,272.65Zm45.6-41.12-3.34,1.94c-.14.08-.16.2,0,.28l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.93c.14-.09.16-.21,0-.28l-3.2-1.85A.53.53,0,0,0,238.82,231.53ZM232.91,235l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l3.34-1.93c.14-.08.16-.2,0-.28l-3.2-1.85A.54.54,0,0,0,232.91,235Zm10.8-6.24-3.34,1.93c-.14.09-.16.21,0,.28l3.2,1.85a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.2,0-.28l-3.2-1.84A.53.53,0,0,0,243.71,228.71Zm-27,25.1,3.34-1.93c.15-.08.16-.2,0-.28l-3.2-1.84a.51.51,0,0,0-.48,0L213,251.7c-.14.09-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,216.69,253.81Zm32.4-27.94a.56.56,0,0,0-.49,0l-3.34,1.93c-.15.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28Zm-51,43.95,3.35-1.93c.14-.08.15-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.34,1.93c-.15.08-.16.21,0,.28l3.2,1.85A.51.51,0,0,0,198.1,269.82Zm60-34.61,3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.56.56,0,0,0,258.06,235.21Zm-9.46.18,3.34-1.93c.14-.08.16-.2,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.53.53,0,0,0,248.6,235.39Zm5.06-6.88a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28Zm1-.59,7.77,4.49a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-7.77-4.49a.53.53,0,0,0-.49,0l-3.34,1.93C254.57,227.72,254.56,227.85,254.69,227.92Zm-11.3,6.25-3.34,1.94c-.14.08-.16.2,0,.28l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.93c.14-.09.16-.21,0-.29l-3.2-1.84A.53.53,0,0,0,243.39,234.17ZM206.6,255.42l-3.34,1.93c-.15.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85A.56.56,0,0,0,206.6,255.42Zm46.08-17.37a.53.53,0,0,0,.49,0l3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm-41.19,14.54-3.35,1.94c-.14.08-.15.2,0,.28l3.2,1.84a.51.51,0,0,0,.48,0l3.35-1.93c.14-.09.15-.21,0-.28l-3.2-1.85A.54.54,0,0,0,211.49,252.59ZM173.17,284a.53.53,0,0,0,.49,0L177,282c.14-.09.15-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0L170,281.83c-.14.08-.15.2,0,.28ZM167.49,278l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28L168,278A.56.56,0,0,0,167.49,278Zm11.06,3.11,3.34-1.93c.15-.08.16-.2,0-.28l-3.2-1.84a.51.51,0,0,0-.48,0L174.89,279c-.14.09-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,178.55,281.11Zm4.89-2.82,3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.57.57,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.56.56,0,0,0,183.44,278.29Zm4.89-2.82,3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.56.56,0,0,0,188.33,275.47Zm-16-.29L169,277.11c-.14.08-.15.2,0,.28l3.2,1.84a.53.53,0,0,0,.49,0l3.35-1.93c.14-.09.15-.21,0-.28l-3.2-1.85A.51.51,0,0,0,172.38,275.18Zm4.89-2.83-3.35,1.93c-.14.09-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.94c.15-.08.16-.2,0-.28l-3.2-1.84A.51.51,0,0,0,177.27,272.35Zm19.55-11.29L193.48,263c-.14.09-.16.21,0,.28l3.2,1.85a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.2,0-.28l-3.2-1.84A.53.53,0,0,0,196.82,261.06Zm-4.89,2.82-3.34,1.94c-.14.08-.16.2,0,.28l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.93c.14-.09.16-.21,0-.28l-3.2-1.85A.56.56,0,0,0,191.93,263.88Zm9.78-5.64-3.34,1.93c-.15.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85A.56.56,0,0,0,201.71,258.24Zm-19.55,11.29-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85A.54.54,0,0,0,182.16,269.53Zm4.88-2.82-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85A.56.56,0,0,0,187,266.71Zm-6.24,18.38,3.35-1.93c.14-.08.15-.21,0-.28L181,281a.56.56,0,0,0-.49,0L177.15,283c-.14.08-.16.21,0,.28l3.2,1.85A.54.54,0,0,0,180.8,285.09ZM155,283.87,151.82,282a.51.51,0,0,0-.48,0L148,284c-.14.09-.15.21,0,.29l3.2,1.84a.51.51,0,0,0,.48,0l3.35-1.93C155.14,284.07,155.15,284,155,283.87Zm6.37,1.6-3.2-1.84a.53.53,0,0,0-.49,0l-5.14,3c-.15.09-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l5.15-3C161.51,285.67,161.52,285.55,161.4,285.47Zm-11.15-5.24-3.2-1.85a.56.56,0,0,0-.49,0l-4.11,2.38c-.15.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l4.12-2.37C150.36,280.42,150.37,280.3,150.25,280.23Zm3.15-1.83a.53.53,0,0,0,.49,0l3.35-1.94c.14-.08.15-.2,0-.28l-3.2-1.84a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.09-.15.21,0,.29Zm13.86,9-3.2-1.85a.56.56,0,0,0-.49,0l-6.43,3.71c-.14.09-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l6.44-3.72C167.37,287.57,167.38,287.44,167.26,287.37Zm2.25,4-3.2-1.85a.51.51,0,0,0-.48,0l-4.12,2.37c-.14.08-.16.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l4.11-2.37C169.62,291.55,169.64,291.42,169.51,291.35Zm20.24-33.93a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28ZM180,263.06a.51.51,0,0,0,.48,0l3.35-1.94c.14-.08.15-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.35,1.93c-.14.09-.15.21,0,.28Zm-21.69,12.52a.53.53,0,0,0,.49,0l3.34-1.93c.15-.08.16-.2,0-.28L159,271.5a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm26.57-15.34a.53.53,0,0,0,.49,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm-9.77,5.65a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0l-3.34,1.93c-.15.08-.16.2,0,.28Zm-3.18,25.65a.54.54,0,0,0-.48,0l-5.15,3c-.14.08-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l5.14-3c.15-.08.16-.21,0-.28Zm-3.84-21.6a.56.56,0,0,0,.49,0L171.9,268c.14-.08.16-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.2,0,.28Zm-4.89,2.82a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0L160,270.63c-.14.08-.15.21,0,.28Zm99.3-33.51a.54.54,0,0,0-.48,0L253.76,244c-.14.09-.15.21,0,.28l3.2,1.85a.51.51,0,0,0,.48,0l8.24-4.75c.14-.08.15-.21,0-.28Zm-10.8,6.24a.56.56,0,0,0-.49,0l-3.34,1.93c-.15.08-.16.21,0,.28l3.2,1.85a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28Zm-66,36.78,3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0L182,280.16c-.15.08-.16.2,0,.28l3.2,1.85A.54.54,0,0,0,185.69,282.27Zm56.21-31.13a.53.53,0,0,0-.49,0l-3.34,1.94c-.14.08-.16.2,0,.28l3.2,1.84a.53.53,0,0,0,.49,0l3.34-1.93c.14-.09.16-.21,0-.28Zm25.47-14.71a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28Zm8.09-1L267.69,231a.56.56,0,0,0-.49,0l-3.34,1.94c-.14.08-.16.2,0,.28l7.77,4.48a.53.53,0,0,0,.49,0l3.34-1.93C275.58,235.65,275.59,235.53,275.46,235.46Zm-51.83,26.23a.51.51,0,0,0-.48,0L219,264.08c-.14.08-.16.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l4.11-2.38c.14-.08.16-.2,0-.28ZM236,254.55a.54.54,0,0,0-.48,0l-5.15,3c-.14.08-.16.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l5.14-3c.15-.08.16-.21,0-.28Zm-23.67,13.67a.56.56,0,0,0-.49,0l-27.53,15.89c-.14.09-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l27.53-15.89c.14-.08.16-.21,0-.28ZM183.23,285a.54.54,0,0,0-.48,0l-4.12,2.38c-.14.08-.15.21,0,.28l3.2,1.85a.53.53,0,0,0,.49,0l4.12-2.37c.14-.09.15-.21,0-.28ZM218,265a.56.56,0,0,0-.49,0l-4.11,2.38c-.14.08-.16.2,0,.28l3.2,1.84a.51.51,0,0,0,.48,0l4.12-2.38c.14-.08.16-.21,0-.28Zm-40.4,23.33a.51.51,0,0,0-.48,0L173,290.67c-.14.08-.15.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l4.11-2.38c.15-.08.16-.2,0-.28Zm51.72-29.86a.51.51,0,0,0-.48,0l-4.12,2.38c-.14.08-.16.21,0,.28l3.2,1.85a.56.56,0,0,0,.49,0l4.11-2.38c.15-.08.16-.2,0-.28Zm17.5-10.11a.56.56,0,0,0-.49,0L243,250.26c-.14.08-.16.21,0,.28l3.2,1.85a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.2,0-.28Zm11-7.64,3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85A.56.56,0,0,0,257.74,240.67Zm-20,1,3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,237.79,241.63Zm-13,18.06,9.78-5.65c.14-.08.16-.2,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-9.77,5.65c-.15.08-.16.2,0,.28l3.2,1.84A.51.51,0,0,0,224.8,259.69Zm27.56-16.18a.53.53,0,0,0,.49,0l3.35-1.94c.14-.08.15-.2,0-.28l-3.2-1.84a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.09-.15.21,0,.28Zm-4.08-2.65,3.34-1.94c.15-.08.16-.2,0-.28l-3.2-1.84a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.09-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,248.28,240.86Zm-28.37,21.65,3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.54.54,0,0,0,219.91,262.51Zm21.65-12.76a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.34,1.93c-.15.09-.16.21,0,.28Zm-46.09,26.87,3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28l3.21,1.85A.51.51,0,0,0,195.47,276.62Zm4.89-2.82,3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28l3.2,1.85A.56.56,0,0,0,200.36,273.8Zm-9.78,5.65,3.35-1.94c.14-.08.15-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.35,1.93c-.14.09-.15.21,0,.28l3.2,1.85A.51.51,0,0,0,190.58,279.45Zm19.56-11.29,3.34-1.94c.14-.08.16-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0L206.48,266c-.14.09-.15.21,0,.28l3.2,1.85A.53.53,0,0,0,210.14,268.16ZM205.25,271l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.51.51,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.2,0,.28l3.2,1.84A.53.53,0,0,0,205.25,271Zm9.78-5.65,3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28l3.2,1.85A.53.53,0,0,0,215,265.33Zm26.67-39.26a.56.56,0,0,0,.49,0l3.35-1.93c.14-.08.15-.21,0-.28l-.85-.49a.51.51,0,0,0-.48,0l-3.35,1.94c-.14.08-.15.2,0,.28Zm-24.29,15.38a.51.51,0,0,0,.48,0l3.35-1.94c.14-.08.15-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.35,1.93c-.14.09-.15.21,0,.28Zm9.77-5.64a.56.56,0,0,0,.49,0l3.34-1.93c.15-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0L224,233.68c-.14.08-.15.21,0,.28Zm-15.74,9.09a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm10.85-6.27a.53.53,0,0,0,.49,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm-20.63,11.91a.51.51,0,0,0,.48,0l3.35-1.93c.14-.09.15-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.94c-.15.08-.16.2,0,.28Zm4.89-2.82a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.2,0-.28l-3.2-1.84a.53.53,0,0,0-.49,0l-3.34,1.93c-.15.09-.16.21,0,.28Zm25.38-16a.51.51,0,0,0,.48,0l3.35-1.94c.14-.08.15-.2,0-.28l-.86-.49a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm14.66-8.47a.53.53,0,0,0,.49,0l3.34-1.93c.15-.09.16-.21,0-.28l-.85-.5a.54.54,0,0,0-.48,0l-3.35,1.93c-.14.08-.15.21,0,.28Zm6.73,3.89a.54.54,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-3.2-1.85a.53.53,0,0,0-.49,0L250.14,225c-.14.08-.15.21,0,.28Zm9.31,10.72,3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.54.54,0,0,0-.48,0L259,235.74c-.14.08-.15.21,0,.28l3.2,1.85A.56.56,0,0,0,262.63,237.85Zm-25.81-9a.51.51,0,0,0,.48,0l3.35-1.93c.14-.08.15-.21,0-.28l-.86-.49a.51.51,0,0,0-.48,0L236,228.12c-.14.08-.15.21,0,.28Zm-40,24.48a.56.56,0,0,0,.49,0l3.34-1.93c.14-.08.16-.21,0-.28l-3.2-1.85a.56.56,0,0,0-.49,0l-3.34,1.93c-.14.08-.16.21,0,.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-311"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "210.77 281.19 211.5 281.61 230.82 292.76 265.17 272.92 265.89 272.51 245.84 260.94 210.77 281.19",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.73 273.18 245.84 262.28 211.94 281.86 230.82 292.76 264.73 273.18",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.73 273.18 245.84 262.28 211.94 281.86 230.82 292.76 264.73 273.18",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,274c-1.4-.64-1.78-1.75-1.91-3.7l-6.25-91.4a6.34,6.34,0,0,1,2.94-5.37L226.48,106.4c1.76-1,3.05-1.57,4.67-.46s1.66,1.72,1.79,3.68L239.19,201a6.36,6.36,0,0,1-2.94,5.38L120,273.51C118.23,274.52,117.24,274.82,115.44,274Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,274c-1.4-.64-1.78-1.75-1.91-3.7l-6.25-91.4a6.34,6.34,0,0,1,2.94-5.37L226.48,106.4c1.76-1,3.05-1.57,4.67-.46s1.66,1.72,1.79,3.68L239.19,201a6.36,6.36,0,0,1-2.94,5.38L120,273.51C118.23,274.52,117.24,274.82,115.44,274Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94,109.61c-.13-2-1.67-2.71-3.42-1.69L113.26,175a6,6,0,0,0-2.18,2.34l-3-1.53h0a6.16,6.16,0,0,1,2.18-2.34L226.48,106.4c1.76-1,3.05-1.58,4.67-.46S232.81,107.66,232.94,109.61Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94,109.61c-.13-2-1.67-2.71-3.42-1.69L113.26,175a6,6,0,0,0-2.18,2.34l-3-1.53h0a6.16,6.16,0,0,1,2.18-2.34L226.48,106.4c1.76-1,3.05-1.58,4.67-.46S232.81,107.66,232.94,109.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.75,273.64a4,4,0,0,1-4.31.35c-1.31-.55-1.78-1.75-1.91-3.7l-6.25-91.4a5.72,5.72,0,0,1,.77-3l3,1.52h0a5.67,5.67,0,0,0-.76,3l6.24,91.4A2.06,2.06,0,0,0,119.75,273.64Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.28,178.53,227.16,114c1.05-.61,2-.15,2.05,1L235,200.24a3.81,3.81,0,0,1-1.76,3.23L121.4,268c-1.06.61-2,.15-2.06-1l-5.83-85.26A3.8,3.8,0,0,1,115.28,178.53Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.28,178.53a3.8,3.8,0,0,0-1.77,3.23l5.74,83.84,110.6-63.84a3.79,3.79,0,0,0,1.76-3.22l-5.73-83.84Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.26,122.5a.59.59,0,0,0,0-.19s0,0,0,0a1.06,1.06,0,0,0-.06-.19,1,1,0,0,0-.16-.26.28.28,0,0,0-.08-.11.27.27,0,0,0-.07-.08l-.16-.13h0a1.24,1.24,0,0,0-.2-.1,1.72,1.72,0,0,0-1.52.21L126.86,184.94c-1.21.69-2.12,2.35-2,4.69l5.4,79.23-.06-1,0,.46a1.51,1.51,0,0,0,.9,1.25l.11.06.12.06.2.05a1.43,1.43,0,0,0,.29,0,1.55,1.55,0,0,0,.74-.21l.06,0h0l2.09-1.2,107.93-62.14a4.32,4.32,0,0,0,2-3.69l-5.43-79.73A2.51,2.51,0,0,0,239.26,122.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,121.39a1.72,1.72,0,0,0-1.52.21L126.86,184.94a4.34,4.34,0,0,0-2,3.69l.28,4.08-3-1.51-.28-4a4.33,4.33,0,0,1,2-3.68l110.09-63.34a1.65,1.65,0,0,1,1.64-.16C236,120.2,238,121.16,238.46,121.39Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.29,122.75c-.1-1.33-1.15-1.84-2.35-1.15L126.86,184.94a4.36,4.36,0,0,0-2,3.69l.29,4.08,114.45-65.85Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.94,121.6,126.86,184.94a4.16,4.16,0,0,0-1.49,1.59l-3-1.49a4,4,0,0,1,1.47-1.56l110.09-63.34a1.68,1.68,0,0,1,1.64-.16c.42.22,2.37,1.17,2.87,1.4A1.74,1.74,0,0,0,236.94,121.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,191.21l-.27-4.05a3.91,3.91,0,0,1,.55-2.12l3,1.49a3.89,3.89,0,0,0-.53,2.1l.28,4.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.64,127.26a2,2,0,0,0-.75,1.71c.05.68.46,1,.92.75a2,2,0,0,0,.74-1.71C231.51,127.33,231.1,127,230.64,127.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.63,125.53a2,2,0,0,0-.75,1.71c.05.68.46,1,.92.75a1.93,1.93,0,0,0,.74-1.71C234.5,125.6,234.09,125.27,233.63,125.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.62,123.8a2,2,0,0,0-.75,1.71c0,.68.46,1,.92.75a2,2,0,0,0,.75-1.71C237.49,123.87,237.08,123.54,236.62,123.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.17,269.59l-.12-.06-2.48-1.24a2.36,2.36,0,0,1-1.3-1.6c0-.1,0-.21,0-.31L122.1,191.2l3,1.51,5.16,75.62a1.43,1.43,0,0,0,.79,1.18l.07,0,0,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-311",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.51,235.91l3-1.72c.3-.17.56,0,.58.29l.07,1.05a1.08,1.08,0,0,1-.5.92l-3,1.72c-.3.17-.56,0-.58-.29l-.07-1A1.08,1.08,0,0,1,134.51,235.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.79,240.11l3-1.72c.3-.18.56,0,.59.28l.07,1.06a1.07,1.07,0,0,1-.5.91l-3,1.72c-.3.18-.56,0-.58-.29l-.08-1A1.07,1.07,0,0,1,134.79,240.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.08,244.3l3-1.72c.3-.17.56,0,.58.29l.07,1a1.08,1.08,0,0,1-.5.92l-3,1.72a.35.35,0,0,1-.58-.29l-.07-1.06A1.07,1.07,0,0,1,135.08,244.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,248.49l3-1.72c.3-.17.56,0,.58.29l.07,1.06a1.07,1.07,0,0,1-.5.91l-3,1.72c-.3.17-.56,0-.58-.29l-.07-1.05A1.08,1.08,0,0,1,135.37,248.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.09,215.11l3-1.72c.3-.18.56,0,.58.28l.07,1.06a1,1,0,0,1-.5.91l-3,1.72c-.3.18-.56,0-.58-.29l-.07-1A1.07,1.07,0,0,1,133.09,215.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,219.3l3-1.72a.35.35,0,0,1,.58.29l.07,1a1.09,1.09,0,0,1-.5.92l-3,1.72c-.3.17-.56,0-.58-.29l-.08-1.06A1.08,1.08,0,0,1,133.38,219.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.66,223.5l3-1.73c.3-.17.56,0,.58.29l.08,1.06a1.1,1.1,0,0,1-.5.91l-3,1.72a.36.36,0,0,1-.59-.29l-.07-1.05A1.07,1.07,0,0,1,133.66,223.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,227.69l3-1.72c.3-.17.56,0,.58.29l.07,1.05a1.1,1.1,0,0,1-.5.92l-3,1.72c-.3.17-.56,0-.58-.29l-.07-1.06A1,1,0,0,1,134,227.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.93,256.72l3-1.72c.3-.18.56-.05.58.29l.07,1a1.07,1.07,0,0,1-.5.91l-3,1.72c-.3.18-.56,0-.58-.28l-.07-1.06A1,1,0,0,1,135.93,256.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.21,260.91l3-1.72a.36.36,0,0,1,.59.29l.07,1a1.08,1.08,0,0,1-.5.92l-3,1.72a.36.36,0,0,1-.59-.29l-.07-1.05A1.08,1.08,0,0,1,136.21,260.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.67,194.3l3-1.72c.3-.17.56,0,.58.29l.07,1a1.07,1.07,0,0,1-.5.92l-3,1.72a.35.35,0,0,1-.58-.29l-.07-1.06A1.07,1.07,0,0,1,131.67,194.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,198.5l3-1.73c.3-.17.56,0,.58.29l.07,1.06a1.07,1.07,0,0,1-.5.91l-3,1.72c-.3.17-.56.05-.58-.29l-.07-1.05A1,1,0,0,1,132,198.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24,202.69l3-1.72c.3-.17.56,0,.58.29l.08,1.05a1.1,1.1,0,0,1-.5.92l-3,1.72a.36.36,0,0,1-.59-.29l-.07-1.06A1.07,1.07,0,0,1,132.24,202.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,206.88l3-1.72c.3-.17.56,0,.58.29l.07,1.06a1,1,0,0,1-.5.91l-3,1.72c-.3.17-.56,0-.58-.29l-.07-1A1.1,1.1,0,0,1,132.53,206.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.38,170.35l-21.6,12.47a2.89,2.89,0,0,0-1.34,2.45l2.13,31.3c.06.89.76,1.24,1.56.78l21.6-12.48a2.87,2.87,0,0,0,1.35-2.45l-2.14-31.3C236.88,170.23,236.18,169.89,235.38,170.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,194.18l-2,1.15a1.43,1.43,0,0,0-.68,1.19c0,.42.38.57.79.34l2-1.15a1.43,1.43,0,0,0,.68-1.19C235.68,194.1,235.33,194,234.92,194.18Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,194.18l-2,1.15a1.43,1.43,0,0,0-.68,1.19c0,.42.38.57.79.34l2-1.15a1.43,1.43,0,0,0,.68-1.19C235.68,194.1,235.33,194,234.92,194.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,174.53l-2,1.15a1.41,1.41,0,0,0-.68,1.19c0,.42.38.57.79.34l2-1.15a1.44,1.44,0,0,0,.68-1.19C234.34,174.45,234,174.29,233.58,174.53Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,174.53l-2,1.15a1.41,1.41,0,0,0-.68,1.19c0,.42.38.57.79.34l2-1.15a1.44,1.44,0,0,0,.68-1.19C234.34,174.45,234,174.29,233.58,174.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,180.06l-2,1.15a1.43,1.43,0,0,0-.69,1.19c0,.42.38.58.79.34l2-1.15a1.41,1.41,0,0,0,.68-1.19C231.81,180,231.46,179.83,231.05,180.06Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,180.06l-2,1.15a1.43,1.43,0,0,0-.69,1.19c0,.42.38.58.79.34l2-1.15a1.41,1.41,0,0,0,.68-1.19C231.81,180,231.46,179.83,231.05,180.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.32,184l-2,1.15a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l2-1.15a1.41,1.41,0,0,0,.68-1.19C232.08,183.9,231.73,183.75,231.32,184Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.32,184l-2,1.15a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l2-1.15a1.41,1.41,0,0,0,.68-1.19C232.08,183.9,231.73,183.75,231.32,184Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.39,186.32l-2,1.15a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.42,1.42,0,0,0,.68-1.19C235.14,186.23,234.79,186.08,234.39,186.32Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.39,186.32l-2,1.15a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.42,1.42,0,0,0,.68-1.19C235.14,186.23,234.79,186.08,234.39,186.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.86,191.85l-2,1.16a1.39,1.39,0,0,0-.68,1.18c0,.43.38.58.78.35l2-1.15a1.42,1.42,0,0,0,.68-1.19C232.62,191.77,232.26,191.62,231.86,191.85Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.86,191.85l-2,1.16a1.39,1.39,0,0,0-.68,1.18c0,.43.38.58.78.35l2-1.15a1.42,1.42,0,0,0,.68-1.19C232.62,191.77,232.26,191.62,231.86,191.85Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.14,177.67l-12.15,7a1.41,1.41,0,0,0-.68,1.18c0,.43.38.58.79.35l12.14-7a1.39,1.39,0,0,0,.68-1.19C228.89,177.59,228.54,177.44,228.14,177.67Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.14,177.67l-12.15,7a1.41,1.41,0,0,0-.68,1.18c0,.43.38.58.79.35l12.14-7a1.39,1.39,0,0,0,.68-1.19C228.89,177.59,228.54,177.44,228.14,177.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,197.33l-12.15,7a1.41,1.41,0,0,0-.68,1.19c0,.42.38.57.79.34l12.14-7a1.42,1.42,0,0,0,.68-1.19C230.23,197.24,229.88,197.09,229.48,197.33Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,197.33l-12.15,7a1.41,1.41,0,0,0-.68,1.19c0,.42.38.57.79.34l12.14-7a1.42,1.42,0,0,0,.68-1.19C230.23,197.24,229.88,197.09,229.48,197.33Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.61,183.21l-9.35,5.41a1.39,1.39,0,0,0-.68,1.18c0,.43.38.58.78.35l9.35-5.41a1.45,1.45,0,0,0,.69-1.19C226.37,183.13,226,183,225.61,183.21Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.61,183.21l-9.35,5.41a1.39,1.39,0,0,0-.68,1.18c0,.43.38.58.78.35l9.35-5.41a1.45,1.45,0,0,0,.69-1.19C226.37,183.13,226,183,225.61,183.21Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,187.14l-9.35,5.41a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l9.35-5.41a1.42,1.42,0,0,0,.68-1.19C226.63,187.06,226.28,186.9,225.88,187.14Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,187.14l-9.35,5.41a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l9.35-5.41a1.42,1.42,0,0,0,.68-1.19C226.63,187.06,226.28,186.9,225.88,187.14Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.94,189.46l-12.14,7a1.42,1.42,0,0,0-.69,1.19c0,.42.39.57.79.34L229,191a1.4,1.4,0,0,0,.69-1.18C229.7,189.38,229.35,189.23,228.94,189.46Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.94,189.46l-12.14,7a1.42,1.42,0,0,0-.69,1.19c0,.42.39.57.79.34L229,191a1.4,1.4,0,0,0,.69-1.18C229.7,189.38,229.35,189.23,228.94,189.46Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.41,195l-9.35,5.41a1.41,1.41,0,0,0-.68,1.19c0,.42.38.57.79.34l9.35-5.41a1.43,1.43,0,0,0,.68-1.19C227.17,194.92,226.82,194.77,226.41,195Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.41,195l-9.35,5.41a1.41,1.41,0,0,0-.68,1.19c0,.42.38.57.79.34l9.35-5.41a1.43,1.43,0,0,0,.68-1.19C227.17,194.92,226.82,194.77,226.41,195Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.46,202.08l-2,1.15a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l2-1.15a1.4,1.4,0,0,0,.69-1.19C236.22,202,235.87,201.85,235.46,202.08Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.46,202.08l-2,1.15a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l2-1.15a1.4,1.4,0,0,0,.69-1.19C236.22,202,235.87,201.85,235.46,202.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4,199.76l-2,1.15a1.4,1.4,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.4,1.4,0,0,0,.68-1.19C233.15,199.68,232.8,199.52,232.4,199.76Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4,199.76l-2,1.15a1.4,1.4,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.4,1.4,0,0,0,.68-1.19C233.15,199.68,232.8,199.52,232.4,199.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,205.23l-12.15,7a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l12.14-7a1.4,1.4,0,0,0,.68-1.19C230.77,205.15,230.42,205,230,205.23Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,205.23l-12.15,7a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l12.14-7a1.4,1.4,0,0,0,.68-1.19C230.77,205.15,230.42,205,230,205.23Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,202.9l-9.35,5.41a1.43,1.43,0,0,0-.68,1.19c0,.42.38.57.79.34l9.35-5.41a1.41,1.41,0,0,0,.68-1.18C227.71,202.82,227.36,202.67,227,202.9Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,202.9l-9.35,5.41a1.43,1.43,0,0,0-.68,1.19c0,.42.38.57.79.34l9.35-5.41a1.41,1.41,0,0,0,.68-1.18C227.71,202.82,227.36,202.67,227,202.9Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18,138.15l-21.6,12.47a2.9,2.9,0,0,0-1.34,2.45l1.64,24c.06.89.76,1.24,1.56.78L235,165.37a2.89,2.89,0,0,0,1.34-2.45l-1.63-24C234.68,138,234,137.69,233.18,138.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,162l-2,1.15a1.42,1.42,0,0,0-.68,1.19c0,.43.38.58.78.34l2-1.15a1.39,1.39,0,0,0,.68-1.18C233.48,161.9,233.13,161.75,232.73,162Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,162l-2,1.15a1.42,1.42,0,0,0-.68,1.19c0,.43.38.58.78.34l2-1.15a1.39,1.39,0,0,0,.68-1.18C233.48,161.9,233.13,161.75,232.73,162Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,142.33l-2,1.15a1.42,1.42,0,0,0-.68,1.19c0,.42.38.58.78.34l2-1.15a1.39,1.39,0,0,0,.68-1.19C232.14,142.25,231.79,142.1,231.39,142.33Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,142.33l-2,1.15a1.42,1.42,0,0,0-.68,1.19c0,.42.38.58.78.34l2-1.15a1.39,1.39,0,0,0,.68-1.19C232.14,142.25,231.79,142.1,231.39,142.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,147.87l-2,1.15a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.42,1.42,0,0,0,.68-1.19C229.62,147.79,229.26,147.63,228.86,147.87Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,147.87l-2,1.15a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.42,1.42,0,0,0,.68-1.19C229.62,147.79,229.26,147.63,228.86,147.87Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,151.79l-2,1.15a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.42,1.42,0,0,0,.68-1.19C229.88,151.71,229.53,151.55,229.13,151.79Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,151.79l-2,1.15a1.39,1.39,0,0,0-.68,1.19c0,.42.38.57.78.34l2-1.15a1.42,1.42,0,0,0,.68-1.19C229.88,151.71,229.53,151.55,229.13,151.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,154.12l-2,1.15a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l2-1.15a1.44,1.44,0,0,0,.69-1.19C233,154,232.6,153.89,232.19,154.12Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,154.12l-2,1.15a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l2-1.15a1.44,1.44,0,0,0,.69-1.19C233,154,232.6,153.89,232.19,154.12Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,159.66l-2,1.15A1.43,1.43,0,0,0,227,162c0,.42.38.57.79.34l2-1.15a1.43,1.43,0,0,0,.68-1.19C230.42,159.58,230.07,159.43,229.66,159.66Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,159.66l-2,1.15A1.43,1.43,0,0,0,227,162c0,.42.38.57.79.34l2-1.15a1.43,1.43,0,0,0,.68-1.19C230.42,159.58,230.07,159.43,229.66,159.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,145.48l-12.14,7a1.44,1.44,0,0,0-.69,1.19c0,.42.39.57.79.34L226,147a1.43,1.43,0,0,0,.69-1.19C226.7,145.4,226.35,145.24,225.94,145.48Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,145.48l-12.14,7a1.44,1.44,0,0,0-.69,1.19c0,.42.39.57.79.34L226,147a1.43,1.43,0,0,0,.69-1.19C226.7,145.4,226.35,145.24,225.94,145.48Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.28,165.13l-12.14,7a1.45,1.45,0,0,0-.69,1.19c0,.42.39.58.79.34l12.15-7a1.43,1.43,0,0,0,.68-1.19C228,165.05,227.69,164.9,227.28,165.13Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.28,165.13l-12.14,7a1.45,1.45,0,0,0-.69,1.19c0,.42.39.58.79.34l12.15-7a1.43,1.43,0,0,0,.68-1.19C228,165.05,227.69,164.9,227.28,165.13Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41,151l-9.35,5.41a1.43,1.43,0,0,0-.68,1.19c0,.42.38.57.79.34l9.35-5.41a1.41,1.41,0,0,0,.68-1.19C224.17,150.93,223.82,150.78,223.41,151Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41,151l-9.35,5.41a1.43,1.43,0,0,0-.68,1.19c0,.42.38.57.79.34l9.35-5.41a1.41,1.41,0,0,0,.68-1.19C224.17,150.93,223.82,150.78,223.41,151Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.68,154.94l-9.35,5.41a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l9.35-5.41a1.41,1.41,0,0,0,.68-1.19C224.44,154.86,224.09,154.71,223.68,154.94Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.68,154.94l-9.35,5.41a1.44,1.44,0,0,0-.68,1.19c0,.42.38.58.79.34l9.35-5.41a1.41,1.41,0,0,0,.68-1.19C224.44,154.86,224.09,154.71,223.68,154.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,157.27l-12.14,7a1.42,1.42,0,0,0-.68,1.19c0,.42.38.58.78.34l12.15-7a1.43,1.43,0,0,0,.68-1.19C227.5,157.19,227.15,157,226.74,157.27Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,157.27l-12.14,7a1.42,1.42,0,0,0-.68,1.19c0,.42.38.58.78.34l12.15-7a1.43,1.43,0,0,0,.68-1.19C227.5,157.19,227.15,157,226.74,157.27Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.22,162.81l-9.35,5.4a1.42,1.42,0,0,0-.68,1.19c0,.42.38.58.78.34l9.35-5.4a1.42,1.42,0,0,0,.68-1.19C225,162.72,224.62,162.57,224.22,162.81Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.22,162.81l-9.35,5.4a1.42,1.42,0,0,0-.68,1.19c0,.42.38.58.78.34l9.35-5.4a1.42,1.42,0,0,0,.68-1.19C225,162.72,224.62,162.57,224.22,162.81Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,190.32l21.63-12.49c.3-.17.56-.06.58.26a1,1,0,0,1-.5.88l-21.63,12.49c-.31.18-.57.06-.59-.25A1.06,1.06,0,0,1,139.65,190.32Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.57,204.12l63.66-36.7c.3-.18.56-.06.58.25a1,1,0,0,1-.5.89l-63.66,36.7c-.31.17-.57.06-.59-.26A1,1,0,0,1,140.57,204.12Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,176.6l40.22-23.14c.31-.17.57-.06.59.25a1.06,1.06,0,0,1-.51.89l-40.22,23.15c-.3.17-.57.06-.59-.26A1.09,1.09,0,0,1,163.4,176.6Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,193.6l10.95-6.33c.31-.18.57-.06.59.25a1.06,1.06,0,0,1-.51.89l-11,6.33c-.3.17-.57.06-.59-.25A1.06,1.06,0,0,1,139.87,193.6Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,193.6l10.95-6.33c.31-.18.57-.06.59.25a1.06,1.06,0,0,1-.51.89l-11,6.33c-.3.17-.57.06-.59-.25A1.06,1.06,0,0,1,139.87,193.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,196.86l6.58-3.79c.3-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L140.17,198c-.3.18-.56.06-.58-.25A1,1,0,0,1,140.09,196.86Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,196.86l6.58-3.79c.3-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L140.17,198c-.3.18-.56.06-.58-.25A1,1,0,0,1,140.09,196.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,186l38.11-21.95c.3-.17.56-.06.58.26a1,1,0,0,1-.51.88l-38.11,22c-.3.18-.56.07-.58-.25A1.05,1.05,0,0,1,153,186Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,186l38.11-21.95c.3-.17.56-.06.58.26a1,1,0,0,1-.51.88l-38.11,22c-.3.18-.56.07-.58-.25A1.05,1.05,0,0,1,153,186Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,211.6l58.27-33.67c.3-.17.56-.06.59.26a1.09,1.09,0,0,1-.51.89L147,212.74c-.3.17-.56.06-.58-.25A1,1,0,0,1,146.87,211.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,208.34l58.27-33.68c.3-.18.56-.06.58.25a1.05,1.05,0,0,1-.51.89l-58.26,33.68c-.3.18-.56.06-.59-.25A1.06,1.06,0,0,1,146.65,208.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.43,192.07l10.84-6.29c.3-.17.56-.06.58.26a1,1,0,0,1-.51.88l-10.83,6.29c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,148.43,192.07Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.43,192.07l10.84-6.29c.3-.17.56-.06.58.26a1,1,0,0,1-.51.88l-10.83,6.29c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,148.43,192.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,184.56l42.36-24.27c.31-.17.57-.06.59.25a1.06,1.06,0,0,1-.51.89L161.47,185.7c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,161.39,184.56Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,184.56l42.36-24.27c.31-.17.57-.06.59.25a1.06,1.06,0,0,1-.51.89L161.47,185.7c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,161.39,184.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,200.3l19.19-11c.31-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.89l-19.2,11c-.3.18-.56.07-.58-.25A1.05,1.05,0,0,1,140.31,200.3Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,200.3l19.19-11c.31-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.89l-19.2,11c-.3.18-.56.07-.58-.25A1.05,1.05,0,0,1,140.31,200.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,188.06,204,163.79c.3-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L161.71,189.2c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,161.63,188.06Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,188.06,204,163.79c.3-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L161.71,189.2c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,161.63,188.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,214.9l58.27-33.59c.3-.17.56-.06.59.26a1.09,1.09,0,0,1-.51.89L147.18,216c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,147.1,214.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,218.17l58.27-33.59c.3-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L147.4,219.31c-.3.17-.56.06-.59-.26A1.06,1.06,0,0,1,147.32,218.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,221.43l58.27-33.58c.3-.18.56-.06.58.25a1,1,0,0,1-.51.89l-58.27,33.59c-.3.17-.56.06-.58-.26A1.06,1.06,0,0,1,147.55,221.43Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.84,225.77l58.27-33.58c.3-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88l-58.27,33.58c-.3.18-.57.06-.59-.25A1.07,1.07,0,0,1,147.84,225.77Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,229l2.53-1.46c.31-.18.57-.06.59.25a1.06,1.06,0,0,1-.51.89l-2.53,1.46c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,142.25,229Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,229l2.53-1.46c.31-.18.57-.06.59.25a1.06,1.06,0,0,1-.51.89l-2.53,1.46c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,142.25,229Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,211.1l2.54-1.45c.3-.18.56-.06.58.25a1,1,0,0,1-.51.89l-2.53,1.46c-.3.17-.57.06-.59-.26A1.09,1.09,0,0,1,141,211.1Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,211.1l2.54-1.45c.3-.18.56-.06.58.25a1,1,0,0,1-.51.89l-2.53,1.46c-.3.17-.57.06-.59-.26A1.09,1.09,0,0,1,141,211.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,218.13l2.54-1.46c.3-.17.56-.06.58.26a1.06,1.06,0,0,1-.51.89l-2.53,1.45c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,141.51,218.13Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,218.13l2.54-1.46c.3-.17.56-.06.58.26a1.06,1.06,0,0,1-.51.89l-2.53,1.45c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,141.51,218.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,221.4l2.54-1.46c.3-.17.56-.06.59.26a1.06,1.06,0,0,1-.51.88l-2.54,1.46c-.3.17-.56.06-.59-.26A1.06,1.06,0,0,1,141.73,221.4Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,221.4l2.54-1.46c.3-.17.56-.06.59.26a1.06,1.06,0,0,1-.51.88l-2.54,1.46c-.3.17-.56.06-.59-.26A1.06,1.06,0,0,1,141.73,221.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,224.66l2.53-1.45c.3-.18.57-.06.59.25a1.06,1.06,0,0,1-.51.89L142,225.81c-.3.17-.56.06-.58-.26A1.06,1.06,0,0,1,142,224.66Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,224.66l2.53-1.45c.3-.18.57-.06.59.25a1.06,1.06,0,0,1-.51.89L142,225.81c-.3.17-.56.06-.58-.26A1.06,1.06,0,0,1,142,224.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,231.91l2.54-1.46c.3-.17.56-.06.58.26a1.06,1.06,0,0,1-.51.89l-2.53,1.45c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,142.45,231.91Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,231.91l2.54-1.46c.3-.17.56-.06.58.26a1.06,1.06,0,0,1-.51.89l-2.53,1.45c-.3.18-.57.06-.59-.25A1.06,1.06,0,0,1,142.45,231.91Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,228.75l58.27-33.69c.3-.17.56-.06.58.26a1.06,1.06,0,0,1-.51.89l-58.26,33.68c-.3.17-.56.06-.58-.26A1,1,0,0,1,148,228.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,250l15.66-9c.3-.17.56-.06.58.26a1.06,1.06,0,0,1-.51.89l-15.65,9c-.3.17-.56.06-.58-.26A1,1,0,0,1,149.77,250Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.91,253.3l2.53-1.46c.31-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L144,254.44c-.31.18-.57.06-.59-.25A1.06,1.06,0,0,1,143.91,253.3Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.91,253.3l2.53-1.46c.31-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L144,254.44c-.31.18-.57.06-.59-.25A1.06,1.06,0,0,1,143.91,253.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11,256.25l2.54-1.45c.3-.18.56-.06.58.25a1.05,1.05,0,0,1-.51.89l-2.53,1.45c-.3.18-.57.06-.59-.25A1.07,1.07,0,0,1,144.11,256.25Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11,256.25l2.54-1.45c.3-.18.56-.06.58.25a1.05,1.05,0,0,1-.51.89l-2.53,1.45c-.3.18-.57.06-.59-.25A1.07,1.07,0,0,1,144.11,256.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,252.77l57.77-33.34c.31-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88L150,253.91c-.3.18-.56.06-.58-.25A1,1,0,0,1,150,252.77Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,235.69l58.17-33.49c.31-.18.57-.06.59.25a1.07,1.07,0,0,1-.51.89l-58.17,33.5c-.31.17-.57.06-.59-.26A1.09,1.09,0,0,1,148.62,235.69Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.93,238.94l2.53-1.46c.31-.18.57-.06.59.25a1,1,0,0,1-.51.89L143,240.08c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,142.93,238.94Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.93,238.94l2.53-1.46c.31-.18.57-.06.59.25a1,1,0,0,1-.51.89L143,240.08c-.31.17-.57.06-.59-.26A1.06,1.06,0,0,1,142.93,238.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84,238.92,207,205.42c.31-.17.57-.06.59.26a1.06,1.06,0,0,1-.51.88l-58.17,33.5c-.31.18-.57.06-.59-.25A1.07,1.07,0,0,1,148.84,238.92Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15,242.2l2.54-1.45c.3-.18.56-.06.58.25a1,1,0,0,1-.5.89l-2.54,1.45c-.3.18-.57.07-.59-.25A1.07,1.07,0,0,1,143.15,242.2Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15,242.2l2.54-1.45c.3-.18.56-.06.58.25a1,1,0,0,1-.5.89l-2.54,1.45c-.3.18-.57.07-.59-.25A1.07,1.07,0,0,1,143.15,242.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,242.2l58.18-33.5c.3-.17.56-.06.58.26a1.05,1.05,0,0,1-.5.89l-58.18,33.49c-.3.18-.57.06-.59-.25A1.07,1.07,0,0,1,149.06,242.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,245.47l2.54-1.46c.3-.17.57-.06.59.26a1.09,1.09,0,0,1-.51.89l-2.54,1.45c-.3.18-.56.06-.58-.25A1,1,0,0,1,143.37,245.47Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,245.47l2.54-1.46c.3-.17.57-.06.59.26a1.09,1.09,0,0,1-.51.89l-2.54,1.45c-.3.18-.56.06-.58-.25A1,1,0,0,1,143.37,245.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--program-icons--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-311",
    d: "M79.43,167.23,45,187.08a1.9,1.9,0,0,0-.86,1.48V207.8c0,.54.39.76.86.49l34.46-19.85a1.88,1.88,0,0,0,.86-1.48V167.72C80.29,167.17,79.91,167,79.43,167.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.42,169.26,49,189.11a1.88,1.88,0,0,0-.86,1.48v19.24A1.87,1.87,0,0,0,49,211.3l3.4,1.94a2,2,0,0,0,1.72,0l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V172.66a1.89,1.89,0,0,0-.86-1.48l-3.41-1.93A1.88,1.88,0,0,0,83.42,169.26Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,169.26,49,189.11a1.88,1.88,0,0,0-.86,1.48v19.24A1.87,1.87,0,0,0,49,211.3l3.4,1.94a2,2,0,0,0,1.72,0l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V172.66a1.89,1.89,0,0,0-.86-1.48l-3.41-1.93A1.88,1.88,0,0,0,83.42,169.26Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,172.5c-.07-.43-.42-.58-.85-.34L54.08,192a1.76,1.76,0,0,0-.61.63l-5.1-2.93a1.65,1.65,0,0,1,.59-.61l34.46-19.86a1.93,1.93,0,0,1,1.72,0l3.4,1.93A1.9,1.9,0,0,1,89.39,172.5Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,172.16,54.08,192a1.89,1.89,0,0,0-.86,1.48v19.23c0,.55.39.77.86.5l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V172.66C89.4,172.11,89,171.89,88.54,172.16Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.54,172.16,54.08,192a1.89,1.89,0,0,0-.86,1.48v19.23c0,.55.39.77.86.5l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V172.66C89.4,172.11,89,171.89,88.54,172.16Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M61.74,197c0,.15,0,.35,0,.62v1.61c0,.27,0,.47,0,.61a3.58,3.58,0,0,0,.1.69,1.07,1.07,0,0,0,.24.49.59.59,0,0,0,.42.19,1.23,1.23,0,0,0,.63-.2,2.79,2.79,0,0,0,.61-.49,3.24,3.24,0,0,0,.4-.56,2.72,2.72,0,0,0,.23-.57,4.79,4.79,0,0,0,.13-.51,2.64,2.64,0,0,1,.12-.46.63.63,0,0,1,.26-.25l1.44-.83a.12.12,0,0,1,.17,0,.28.28,0,0,1,.07.22,6.66,6.66,0,0,1-.28,1.78,7.79,7.79,0,0,1-.72,1.74,7.92,7.92,0,0,1-1.09,1.52,5.54,5.54,0,0,1-1.34,1.11,3,3,0,0,1-1.42.45,1.58,1.58,0,0,1-1.06-.38,2.38,2.38,0,0,1-.68-1.07,6,6,0,0,1-.27-1.62c0-.45,0-.94,0-1.48s0-1,0-1.53a9.43,9.43,0,0,1,.27-1.93,8.86,8.86,0,0,1,.67-1.85,7.64,7.64,0,0,1,1.07-1.61,5.32,5.32,0,0,1,1.42-1.18,3,3,0,0,1,1.34-.45,1.79,1.79,0,0,1,1.09.27,1.84,1.84,0,0,1,.72.9,3.72,3.72,0,0,1,.28,1.46.67.67,0,0,1-.07.31.54.54,0,0,1-.17.21l-1.44.83c-.13.07-.21.08-.26,0a1,1,0,0,1-.12-.31,1.82,1.82,0,0,0-.13-.37.64.64,0,0,0-.23-.3.7.7,0,0,0-.4-.1,1.33,1.33,0,0,0-.61.22,2.31,2.31,0,0,0-.63.52,3,3,0,0,0-.42.68,3.36,3.36,0,0,0-.24.76A5.6,5.6,0,0,0,61.74,197Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,186.86a2.92,2.92,0,0,1,1.3-.43,1.79,1.79,0,0,1,1,.22,1.71,1.71,0,0,1,.67.69,2.27,2.27,0,0,1,.25,1,.7.7,0,0,1-.07.31.43.43,0,0,1-.16.2l-1.44.83a.44.44,0,0,1-.25.08.35.35,0,0,1-.19-.1l-.11-.1a.41.41,0,0,0-.2-.13.59.59,0,0,0-.33,0,1.29,1.29,0,0,0-.49.18,3.6,3.6,0,0,0-.4.28,2.13,2.13,0,0,0-.34.33,1.47,1.47,0,0,0-.24.4,1.28,1.28,0,0,0-.09.48.5.5,0,0,0,.1.36.45.45,0,0,0,.35.11,2.62,2.62,0,0,0,.66-.09l1-.27a3.22,3.22,0,0,1,1.06-.13,1.25,1.25,0,0,1,.75.28,1.58,1.58,0,0,1,.45.76,4.56,4.56,0,0,1,.15,1.29,5.67,5.67,0,0,1-.25,1.69,7.14,7.14,0,0,1-.71,1.57A7.51,7.51,0,0,1,72.52,198a6.73,6.73,0,0,1-1.36,1,3.23,3.23,0,0,1-1.37.48,1.82,1.82,0,0,1-1.06-.19,1.68,1.68,0,0,1-.7-.72,2.47,2.47,0,0,1-.26-1.12.66.66,0,0,1,.07-.3A.53.53,0,0,1,68,197l1.44-.83a.51.51,0,0,1,.24-.08.36.36,0,0,1,.18.08l.13.14a.76.76,0,0,0,.24.18.7.7,0,0,0,.37.06,1.31,1.31,0,0,0,.56-.2,4,4,0,0,0,1-.76,1.34,1.34,0,0,0,.39-.93.36.36,0,0,0-.14-.34.69.69,0,0,0-.43-.06,3.79,3.79,0,0,0-.73.14l-1,.27a1.59,1.59,0,0,1-1.66-.29,3,3,0,0,1-.52-2,5.84,5.84,0,0,1,.21-1.51,7.26,7.26,0,0,1,1.61-2.9A5.83,5.83,0,0,1,71.1,186.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.07,182.26a2.93,2.93,0,0,1,1.29-.43,1.75,1.75,0,0,1,1,.22,1.65,1.65,0,0,1,.67.69,2.15,2.15,0,0,1,.26,1,.87.87,0,0,1-.07.31.5.5,0,0,1-.16.2l-1.45.83a.39.39,0,0,1-.24.08.38.38,0,0,1-.2-.1l-.1-.1a.46.46,0,0,0-.2-.13.59.59,0,0,0-.33,0,1.18,1.18,0,0,0-.49.18,3.6,3.6,0,0,0-.4.28,2.13,2.13,0,0,0-.34.33,1.47,1.47,0,0,0-.24.4,1.12,1.12,0,0,0-.1.48.5.5,0,0,0,.11.36.43.43,0,0,0,.35.11,2.61,2.61,0,0,0,.65-.09l1-.27a3.2,3.2,0,0,1,1-.13,1.28,1.28,0,0,1,.76.28,1.58,1.58,0,0,1,.45.76,4.56,4.56,0,0,1,.15,1.29,5.68,5.68,0,0,1-.26,1.69,6.32,6.32,0,0,1-.71,1.57,7.05,7.05,0,0,1-1.07,1.36,6.73,6.73,0,0,1-1.36,1,3.27,3.27,0,0,1-1.37.48,1.82,1.82,0,0,1-1.06-.19A1.68,1.68,0,0,1,76,194a2.34,2.34,0,0,1-.26-1.12.66.66,0,0,1,.07-.3.53.53,0,0,1,.16-.21l1.44-.83a.48.48,0,0,1,.24-.08.36.36,0,0,1,.18.08l.13.14a.76.76,0,0,0,.24.18.7.7,0,0,0,.37.06,1.31,1.31,0,0,0,.56-.2,4,4,0,0,0,1-.76,1.34,1.34,0,0,0,.39-.93.38.38,0,0,0-.14-.34.69.69,0,0,0-.43-.06,3.65,3.65,0,0,0-.73.14l-1,.27a1.59,1.59,0,0,1-1.66-.29,3,3,0,0,1-.52-2,5.84,5.84,0,0,1,.21-1.51,7.44,7.44,0,0,1,.62-1.53,6.63,6.63,0,0,1,1-1.37A5.4,5.4,0,0,1,79.07,182.26Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-311",
    d: "M79.43,207.21,45,227.06a1.9,1.9,0,0,0-.86,1.48v19.24c0,.54.39.76.86.49l34.46-19.85a1.88,1.88,0,0,0,.86-1.48V207.7C80.29,207.15,79.91,206.93,79.43,207.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.42,209.24,49,229.09a1.88,1.88,0,0,0-.86,1.48v19.24a1.87,1.87,0,0,0,.86,1.47l3.4,1.94a2,2,0,0,0,1.72,0l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V212.64a1.89,1.89,0,0,0-.86-1.48l-3.41-1.93A1.88,1.88,0,0,0,83.42,209.24Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,209.24,49,229.09a1.88,1.88,0,0,0-.86,1.48v19.24a1.87,1.87,0,0,0,.86,1.47l3.4,1.94a2,2,0,0,0,1.72,0l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V212.64a1.89,1.89,0,0,0-.86-1.48l-3.41-1.93A1.88,1.88,0,0,0,83.42,209.24Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,212.48c-.07-.43-.42-.58-.85-.34L54.08,232a1.71,1.71,0,0,0-.61.64l-5.1-2.94a1.65,1.65,0,0,1,.59-.61l34.46-19.85a1.9,1.9,0,0,1,1.72,0l3.4,1.93A1.9,1.9,0,0,1,89.39,212.48Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,212.14,54.08,232a1.89,1.89,0,0,0-.86,1.48v19.23c0,.55.39.77.86.5l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V212.64C89.4,212.09,89,211.87,88.54,212.14Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.54,212.14,54.08,232a1.89,1.89,0,0,0-.86,1.48v19.23c0,.55.39.77.86.5l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V212.64C89.4,212.09,89,211.87,88.54,212.14Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M61.9,232.32a.17.17,0,0,1,.21,0,.37.37,0,0,1,.09.27v10.95a.87.87,0,0,1-.09.37.54.54,0,0,1-.21.25l-1.44.84a.17.17,0,0,1-.21,0,.34.34,0,0,1-.09-.27v-4.15L57.72,242v4.15a.81.81,0,0,1-.09.37.47.47,0,0,1-.21.26L56,247.6a.17.17,0,0,1-.21,0,.41.41,0,0,1-.08-.28V236.37a1,1,0,0,1,.08-.37.63.63,0,0,1,.21-.26l1.44-.83a.15.15,0,0,1,.21,0,.34.34,0,0,1,.09.27v4.08l2.44-1.41v-4.08a.88.88,0,0,1,.09-.38.54.54,0,0,1,.21-.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,227.68a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.79a.81.81,0,0,1-.09.37.57.57,0,0,1-.21.26L68,231.51v8.69a.81.81,0,0,1-.09.37.52.52,0,0,1-.21.26l-1.44.83a.16.16,0,0,1-.21,0,.36.36,0,0,1-.08-.27v-8.7L64,233.8a.15.15,0,0,1-.21,0,.37.37,0,0,1-.09-.27v-1.8a.84.84,0,0,1,.09-.37.57.57,0,0,1,.21-.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,233.63a.62.62,0,0,1-.14-.19l-1-2.2v5.61a.87.87,0,0,1-.09.37.56.56,0,0,1-.21.26l-1.44.83a.17.17,0,0,1-.21,0,.38.38,0,0,1-.08-.27V227.08a1,1,0,0,1,.08-.38.54.54,0,0,1,.21-.25l1.28-.74c.15-.08.26-.09.33,0a.81.81,0,0,1,.14.19l1.79,3.66,1.78-5.72c0-.07.07-.19.14-.36a.75.75,0,0,1,.33-.37l1.28-.74a.16.16,0,0,1,.21,0,.37.37,0,0,1,.09.27V233.6a.84.84,0,0,1-.09.37.57.57,0,0,1-.21.26l-1.44.83a.16.16,0,0,1-.21,0,.37.37,0,0,1-.09-.27v-5.61l-1,3.39c0,.11-.09.23-.15.37a.74.74,0,0,1-.26.29l-.71.4C75.15,233.69,75.07,233.69,75,233.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.93,227a.15.15,0,0,1,.21,0,.37.37,0,0,1,.09.27v1.8a.84.84,0,0,1-.09.37.63.63,0,0,1-.21.26l-5.1,2.94a.15.15,0,0,1-.21,0,.38.38,0,0,1-.08-.27V221.45a1,1,0,0,1,.08-.38.54.54,0,0,1,.21-.25l1.45-.83c.08-.05.15-.05.2,0a.37.37,0,0,1,.09.27V229Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-311",
    d: "M79.43,247.19,45,267a1.9,1.9,0,0,0-.86,1.48v19.24c0,.54.39.77.86.49L79.43,268.4a1.88,1.88,0,0,0,.86-1.48V247.68C80.29,247.13,79.91,246.91,79.43,247.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.42,249.22,49,269.07a1.88,1.88,0,0,0-.86,1.48v19.24a1.87,1.87,0,0,0,.86,1.47l3.4,1.94a2,2,0,0,0,1.72,0l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V252.62a1.89,1.89,0,0,0-.86-1.48l-3.41-1.93A1.88,1.88,0,0,0,83.42,249.22Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,249.22,49,269.07a1.88,1.88,0,0,0-.86,1.48v19.24a1.87,1.87,0,0,0,.86,1.47l3.4,1.94a2,2,0,0,0,1.72,0l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V252.62a1.89,1.89,0,0,0-.86-1.48l-3.41-1.93A1.88,1.88,0,0,0,83.42,249.22Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,252.46c-.07-.43-.42-.58-.85-.34L54.08,272a1.71,1.71,0,0,0-.61.64l-5.1-2.94a1.65,1.65,0,0,1,.59-.61l34.46-19.85a1.9,1.9,0,0,1,1.72,0l3.4,1.93A1.9,1.9,0,0,1,89.39,252.46Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,252.12,54.08,272a1.89,1.89,0,0,0-.86,1.48v19.23c0,.55.39.77.86.5l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V252.62C89.4,252.07,89,251.85,88.54,252.12Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.54,252.12,54.08,272a1.89,1.89,0,0,0-.86,1.48v19.23c0,.55.39.77.86.5l34.46-19.86a1.89,1.89,0,0,0,.86-1.48V252.62C89.4,252.07,89,251.85,88.54,252.12Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M62.41,276.52c0,.15,0,.36,0,.62v1.62c0,.26,0,.46,0,.61a3.36,3.36,0,0,0,.1.68,1.07,1.07,0,0,0,.24.49.59.59,0,0,0,.42.19,1.14,1.14,0,0,0,.63-.2,2.34,2.34,0,0,0,.61-.49,2.9,2.9,0,0,0,.4-.56,3.46,3.46,0,0,0,.24-.57q.08-.29.12-.51a2.74,2.74,0,0,1,.12-.45.59.59,0,0,1,.26-.26l1.44-.83a.12.12,0,0,1,.17,0,.29.29,0,0,1,.07.22,7.13,7.13,0,0,1-.27,1.79,8.32,8.32,0,0,1-.73,1.74,8.18,8.18,0,0,1-1.09,1.51,5.54,5.54,0,0,1-1.34,1.11,2.75,2.75,0,0,1-1.42.45,1.63,1.63,0,0,1-1.06-.37,2.42,2.42,0,0,1-.68-1.08,6.36,6.36,0,0,1-.27-1.61c0-.46,0-.95,0-1.48s0-1,0-1.54a9.31,9.31,0,0,1,1-3.78,7.17,7.17,0,0,1,1.06-1.6A5.52,5.52,0,0,1,63.8,271a3,3,0,0,1,1.34-.45,1.87,1.87,0,0,1,1.09.27,1.91,1.91,0,0,1,.73.9,4,4,0,0,1,.27,1.47.66.66,0,0,1-.07.3.54.54,0,0,1-.17.21l-1.44.83c-.13.08-.21.09-.26,0a.89.89,0,0,1-.12-.31,3.16,3.16,0,0,0-.12-.37.8.8,0,0,0-.24-.3.7.7,0,0,0-.4-.1,1.51,1.51,0,0,0-.61.22,2.34,2.34,0,0,0-.63.53,2.91,2.91,0,0,0-.42.67,3.29,3.29,0,0,0-.24.77A5.3,5.3,0,0,0,62.41,276.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.51,274.26v2.8a.84.84,0,0,1-.09.37.55.55,0,0,1-.2.26l-1.39.8a.17.17,0,0,1-.21,0,.34.34,0,0,1-.09-.27v-2.79l-1.7,1a.16.16,0,0,1-.21,0,.38.38,0,0,1-.09-.28v-1.71a.84.84,0,0,1,.09-.37.56.56,0,0,1,.21-.26l1.7-1V270a.87.87,0,0,1,.09-.37.63.63,0,0,1,.21-.26l1.39-.8a.15.15,0,0,1,.2,0,.37.37,0,0,1,.09.27v2.8l1.7-1a.16.16,0,0,1,.21,0,.36.36,0,0,1,.08.27v1.71a.87.87,0,0,1-.08.38.54.54,0,0,1-.21.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.81,270.05v2.8a.87.87,0,0,1-.09.37.54.54,0,0,1-.21.25l-1.39.8c-.08.05-.15.05-.2,0a.37.37,0,0,1-.09-.27v-2.8l-1.71,1a.17.17,0,0,1-.21,0,.34.34,0,0,1-.08-.27v-1.71a.83.83,0,0,1,.08-.37.57.57,0,0,1,.21-.26l1.71-1v-2.8a.84.84,0,0,1,.09-.37.5.5,0,0,1,.2-.26l1.39-.8a.17.17,0,0,1,.21,0,.34.34,0,0,1,.09.27v2.79l1.69-1a.17.17,0,0,1,.21,0,.37.37,0,0,1,.09.27v1.71a.81.81,0,0,1-.09.37.57.57,0,0,1-.21.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.43,285.54s-13.42-8.13-20.66-12.23c-5.76-3.26-10.92-7.26-16.49-7.26-6.18,0-10.34-1.8-14.58-4.23-3.47-2-5.72-3.17-8.79-5a67.24,67.24,0,0,1-8.43-5.39c-1.64-1.37-6.25-4.72-7-6.82s2.19-3.82,5.58-3,8,4.19,11.9,4.93,5.18.81,5.45-1.78-2.4-7-4.1-8.73-5.57-4-8.53-5.23-7.92-3.69-7.92-3.69a60.87,60.87,0,0,1-6.49-2c-2.29-.93-4.13-2.67-4-5.28-2.36-2.31-1-4.58.5-4.51s7.91,1.22,12.4,2.13,10.72,2.6,12.88,3.26,9.13,4.3,13.15,6.29,4.45,2.65,5.61,3.91c1,1.07,4.94,5.4,9.2,9.65,4.61,4.61,6.91,6.16,10.47,7.31,5.44,1.75,26.44,9.58,32.44,10.43C341,264.63,333.25,281,324.43,285.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.34,227.4a32,32,0,0,0-4.74,3c-1.73,1.41.88,4.63,6.56,3.66a59.62,59.62,0,0,0,8.38-1.91Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,219.92c.07-1.4,1.5-2,3.85-1.5s11.33,2.66,14.47,3.39a30.12,30.12,0,0,1,9.18,3.78c3.86,2.21,11.09,7.47,11.09,7.47a50,50,0,0,0-7.4-6.13c-4.81-3.34-6.65-4.59-11.62-5.85s-14.38-3.46-16.31-3.77S240,217.7,240.4,219.92Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.56,235.42c16.72-2.47,32.18,2.1,36.55,20.08,3.23,13.22-15.66,53.79-25.45,77.9,0,0-37.87-1.54-41.11-29.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.43,174.66s-12.69,15.31-11.78,16.7,8,4.63,8,4.63Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.55,147.28c-6.72,2.3-9,8-10.28,19-.52,4.63,1.52,11.76,0,16.58-4.41,13.47-1.59,36.35,2,40.64,2.45,2.9,18.16,7.64,25.91,6.39,9.71-1.56,31.18-8.5,42.58-22.11,13.4-16,18.7-39,7-49.76C399.23,142.85,355.73,144.82,348.55,147.28Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.19,230.24l-.71-12.4L364,224.62l.84,8.61c.47,4.83.85,9.82-2.34,11.69-5.73,3.35-15.19,8.54-21.56,12.42,0,0,27.82,3.39,48.77-.07s18-21.55,18-21.55C406.66,235.76,403.47,236.16,403.19,230.24Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,224.1c3.12,2.23,12.31,6.15,23.61,6.14l-.55-5.62a57,57,0,0,1-13.58,1.23A28.5,28.5,0,0,1,341,224.1Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.75,149.78a9.61,9.61,0,0,0-1.91,5,8.49,8.49,0,0,0,3.88,7.83,7.35,7.35,0,0,0,8.55-.75,9.42,9.42,0,0,0,2.22,8.68c2.22,2.19,6.07,2.73,8.52.81-.76,1.6-1.4,3.81,0,4.91a3,3,0,0,0,1.21.53,6.54,6.54,0,0,0,3.79-.25,6,6,0,0,0-1.6,5.31c.16.62,3.22,4.48,3.39,4,0,0,3.92-10.79,13.11-8.5s9.36,14.4,2.74,21.1-11.78,3.42-11.86,3.37c0,1.94-.22,12.38,8.37,18.41,5.27,3.69,19.12,4.49,26.43.11,2.69-4.82,7.21-11,10.7-16.38,11.68-18.09,15.51-29.23,13.48-39.42-1.38-7-4.48-10.92-9.73-12.24-.29-6.6-1.24-11.69-8.34-17.78-11.14-9.58-24-10.41-34-10-3.44.15-6.9.76-10.31.28-2.94-.42-5.73-1.63-8.66-2.16s-6.29-.18-8.32,2-2.14,5.87-1.36,8.9a14.71,14.71,0,0,0-6.87,2,8.13,8.13,0,0,0-3.91,5.77,5.7,5.7,0,0,0,3.25,5.88A10.48,10.48,0,0,0,335.75,149.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.76,356.89c-4.32,22-7.3,35.22-6.36,57.12l-64.53,38.21-37.09-21.9c.1-38.58.57-40.6-.66-80.21-1.81-57.91,5.65-86,19-96.15,13-5.77,14.75-6.74,21.37-9,3,1.44,10.73,3.81,23.26,2.76,15.54-1.32,22-9.88,21.92-12,0,0,1.37-.16,2.85-.31,2.41.47,6.91,2.31,11.39,4.71,3.78,2.05,13,5.78,16.61,23.29C446.35,301.32,435.12,334.66,430.76,356.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51,236.48a49.65,49.65,0,0,1,10.94,4.57l.81.43c4.2,2.18,12,6.25,15.28,22.15,6.36,31-.19,59.44-5,80.23-1.05,4.57-2.05,8.88-2.82,12.83-.29,1.46-.57,2.88-.84,4.27-3.83,19.38-6.38,32.26-5.57,52.47L359.87,451l-36-21.29c0-8.81.06-15.59.1-21.59.12-19.65.17-27.78-.77-58.05-1.66-53.24,4.4-84.39,18.54-95.21l7-3.13a147.84,147.84,0,0,1,13.78-5.7c2,.88,7.66,2.94,17.25,2.94,2,0,4.06-.08,6.15-.26,8.61-.73,14.19-3.61,17.35-5.89s4.82-4.53,5.36-6.15l1.92-.2m.05-1.06c-1.48.15-2.85.31-2.85.31.11,2.07-6.38,10.63-21.92,12-2.16.18-4.18.26-6.06.26-9,0-14.72-1.83-17.2-3-6.62,2.3-8.37,3.27-21.37,9-13.39,10.15-20.85,38.24-19,96.15,1.23,39.61.76,41.63.66,80.21l37.09,21.9L424.4,414c-.94-21.9,2-35.09,6.36-57.12,4.36-22.23,15.59-55.57,7.8-93.47C435,245.91,425.73,242.18,422,240.13c-4.48-2.4-9-4.24-11.39-4.71Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.72,315c-14.66-9.41-25.31-18-27.43-21.54-2.39-4-5.1-12.61-6.51-19.05a27.46,27.46,0,0,0-3.74-10,37.17,37.17,0,0,0-5-6.66c-.75-.7-3.34,1-3.23,3.95s1.92,5.31,2.26,7.3-1.12,7.33-1.12,7.33-4.1-4.13-8-7.55a35.69,35.69,0,0,0-10-6.79c-4-1.9-6.79-3.07-7.71-3.4s-6.22-2-8.8-2.46-2.59,2-1.24,3.85,9.14,5.54,9.14,5.54-4.23-1-6-1.61a12.36,12.36,0,0,0-5-.74c-2.46,0-5.29-.08-7.2.07-2.9.24-2.33,3.91.73,5.35s7.92,2.09,9.67,2.67a49.61,49.61,0,0,1,7.79,3.83c1,.78,5.92,5,6.13,5.52s-2.41-.92-6.39-2.78-9.74-4.67-11.4-5.25A99.79,99.79,0,0,0,168.35,270c-2.11-.29-2.46,2.64-.82,5.22s7.73,4.2,9.74,5.27,7.66,4.42,10.73,6.31,5.14,3.38,4.81,4.48-2.8.74-6.38.14-8-1.73-10.84-2.45-6.73-2-7.86-.63-.5,3.85,2,4.95,7.19,2.47,10.33,3.46,8.74,2.33,10.77,3a19.76,19.76,0,0,1,7.2,4.94c2,2.21,6.12,8.26,11.34,11.27s9.42,4.16,13.23,8.28c3.68,4,15.58,18,15.58,18A47.88,47.88,0,0,0,252.82,333,28.66,28.66,0,0,0,261.72,315Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.68,275.82a24.84,24.84,0,0,1-1.56-5.48h0a38.94,38.94,0,0,1-1.15,6,41.41,41.41,0,0,1,5.12,7C222,280.74,220.73,278.12,219.68,275.82Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.44,265.53a26.4,26.4,0,0,1,5.63,3.18c1.81,1.36,8.46,6.51,8.46,6.51a41.34,41.34,0,0,0-4-4,25.73,25.73,0,0,0-5.75-4.11A35.52,35.52,0,0,0,190.44,265.53Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276,325s14.33-20.08,27.19-38.79a88.55,88.55,0,0,1,37.58-30.66c20,17.51-.35,65.08-.35,65.08-12.95,14.67-33,38.62-39.15,45.48-11.49,12.79-19.59,18.17-34,5.81a195.12,195.12,0,0,1-22.83-22.59C234.89,338.48,225,326.58,225,326.58l20.38-22.95Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,325c-5.15,6-7.88,12.65-6.24,23.46-4.35-6.73-4.63-17.49,2.77-25.85Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.16,254c-14.48,6.37-23.68,8.93-38.94,31.68-10.68,15.93-24.29,35.26-24.29,35.26s-.13,8.59,12.7,20.63,22.8,12.55,22.8,12.55L341,321.52S365.59,274.53,341.16,254Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M464.09,245.62c-1-.66-5-3.42-6.08-4.12-3.54-2.35-8.65-2.12-14.47,1.24l-52.22,30.09c-11.71,6.75-21.92,23.59-22.81,37.62L359.56,452l6.12,3.54,94.68-55.36L469.23,260C469.67,253,467.68,248,464.09,245.62Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.09,245.62c-1-.66-5-3.42-6.08-4.12-3.54-2.35-8.65-2.12-14.47,1.24l-52.22,30.09c-11.71,6.75-21.92,23.59-22.81,37.62L359.56,452l6.12,3.54,94.68-55.36L469.23,260C469.67,253,467.68,248,464.09,245.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.64,348.48,469.23,260c.44-7.05-1.55-12.05-5.14-14.42-1-.66-5-3.42-6.08-4.12-3.54-2.35-8.65-2.12-14.47,1.24l-52.22,30.09c-6,3.44-11.55,9.52-15.71,16.5Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.64,348.48,469.23,260c.44-7.05-1.55-12.05-5.14-14.42-1-.66-5-3.42-6.08-4.12-3.54-2.35-8.65-2.12-14.47,1.24l-52.22,30.09c-6,3.44-11.55,9.52-15.71,16.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.08,245.63c-3.54-2.35-8.63-2.13-14.45,1.23L397.41,277c-11.71,6.75-21.92,23.59-22.81,37.62l-8.92,141,8.41,4.85,94.63-54.62,8.86-140.18c.44-6.92-1.48-11.85-4.93-14.27C471.2,250.35,465.51,246.58,464.08,245.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71,293.43c-4,6.71-6.68,14.26-7.11,21.14l-8.92,141,8.41,4.85,94.63-54.62L472,354.1Z",
    style: {
      fill: "#37474f",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,460.43,383,320.15c.89-14,11.1-30.87,22.82-37.61L458,252.44c11.71-6.74,20.49-.84,19.6,13.19l-8.86,140.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.8,391.85l74.89,43.25-28.58,16.5-85.76-49.5,17.73-10.24A21.7,21.7,0,0,1,300.8,391.85Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.8,391.85l74.89,43.25-28.58,16.5-85.76-49.5,17.73-10.24A21.7,21.7,0,0,1,300.8,391.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.36 409.77 261.36 402.1 347.11 451.6 347.11 459.28 261.36 409.77",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.36 409.77 261.36 402.1 347.11 451.6 347.11 459.28 261.36 409.77",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.69 435.1 375.18 443.07 347.11 459.28 347.11 451.6 375.69 435.1",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.69 435.1 375.18 443.07 347.11 459.28 347.11 451.6 375.69 435.1",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.8,70.61a31.15,31.15,0,0,1-8.39,21.32l-2.58,2.46a31.16,31.16,0,0,1-44-43.83L365.26,48A31.17,31.17,0,0,1,417.8,70.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.53,36.85a33.83,33.83,0,0,0-5.48,67.2l3.82,9.79a2,2,0,0,0,3.66,0l3.78-9.81a33.83,33.83,0,0,0-5.78-67.17ZM417.8,70.61a31.15,31.15,0,0,1-8.39,21.32l-2.58,2.46a31.16,31.16,0,0,1-44-43.83L365.26,48A31.17,31.17,0,0,1,417.8,70.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,70.61a31.15,31.15,0,0,1-8.39,21.32l-2.58,2.46a31.16,31.16,0,0,1-44-43.83L365.26,48A31.17,31.17,0,0,1,417.8,70.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.82,90.16a5,5,0,0,1-3.61-1.56l-11.2-12a4.95,4.95,0,1,1,7.22-6.76l7.27,7.77,17.22-21.8A4.94,4.94,0,1,1,406.47,62L385.7,88.28A4.9,4.9,0,0,1,382,90.16Z",
    style: {
      fill: "#4169E1"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCoding);
export default __webpack_public_path__ + "static/media/Hand-coding.f16a6c7b75a2c0236ece0789a8569e88.svg";
export { ForwardRef as ReactComponent };